import React, { useState, useEffect, useContext, useRef } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { all_routes } from '../../../router/all_routes';
import CollapseHeader from "../../../../core/common/collapse-header";
import ComposeEmail from './ComposeEmail';
import EmailService, { EmailMessage } from './email.service';
import EmailTabs, { TabKey } from './emailTabs';
import { formatEmailDate, formatFullEmailDate, formatDetailedEmailDate, extractSenderInfo, getEmailProviderTag, extractFileAttachments, FileAttachment, getCrmEntityTag, getCrmEntityTooltip } from './emailUtils';
import { AuthContext } from '../../../../context/authcontext';
import { useEmailProviders } from '../../../../hooks/useEmailProviders';
import { useEmailContext } from '../../../../context/emailContext';
import { showErrorAlert, showSuccessAlert, showDeleteConfirmationAlert } from '../../../../utils/alertUtils';
import { SendEmailPayload } from './email.service';
import { sanitizeAndScopeEmailContent } from '../../../../utils/emailStyleScopingUtils';
import { ChatService } from '../chat/chatService';
import CreatableSelect from 'react-select/creatable';
import { API_BASE_URL } from '../../../../environment';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import male from "../../../../assets/male.png";
import { getLifecycleTypeName } from '../../../../utils/lifecycleUtils';

const MySwal = withReactContent(Swal);

interface EmailChip {
  email: string;
  isValid: boolean;
}

const EmailDetail = () => {
  const { providers } = useEmailProviders();
  const [isComposeOpen, setIsComposeOpen] = useState(false);
  const [draftDataToEdit, setDraftDataToEdit] = useState<EmailMessage | null>(null);
  const [minimizedEmails, setMinimizedEmails] = useState<number[]>([]);
  const [emailData, setEmailData] = useState<EmailMessage | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [showDetails, setShowDetails] = useState(false);
  const [isReplyMode, setIsReplyMode] = useState(false);
  const [replyContent, setReplyContent] = useState('');
  const [sendingReply, setSendingReply] = useState(false);
  const [replyCc, setReplyCc] = useState('');
  const [replyCcChips, setReplyCcChips] = useState<EmailChip[]>([]);
  const [showReplyCc, setShowReplyCc] = useState(false);
  const [replyRecipient, setReplyRecipient] = useState('');
  const [replyRecipientChips, setReplyRecipientChips] = useState<EmailChip[]>([]);
  const [isForwardMode, setIsForwardMode] = useState(false);
  const [forwardContent, setForwardContent] = useState('');
  const [forwardRecipient, setForwardRecipient] = useState('');
  const [forwardRecipientChips, setForwardRecipientChips] = useState<EmailChip[]>([]);
  const [sendingForward, setSendingForward] = useState(false);
  const [optionalMessage, setOptionalMessage] = useState('');
  const [forwardCc, setForwardCc] = useState('');
  const [forwardCcChips, setForwardCcChips] = useState<EmailChip[]>([]);
  const [showForwardCc, setShowForwardCc] = useState(false);
  const [replyAttachments, setReplyAttachments] = useState<File[]>([]);
  const [forwardAttachments, setForwardAttachments] = useState<File[]>([]);
  const [isForwardDropdownOpen, setIsForwardDropdownOpen] = useState(true);
  const [showForwardLinkInput, setShowForwardLinkInput] = useState(false);
  const [forwardLinkUrl, setForwardLinkUrl] = useState('');
  const [forwardLinkText, setForwardLinkText] = useState('');
  const [storedRange, setStoredRange] = useState<Range | null>(null);
  const replyFileInputRef = useRef<HTMLInputElement>(null);
  const forwardFileInputRef = useRef<HTMLInputElement>(null);
  const forwardMessageRef = useRef<HTMLDivElement>(null);

  const [forwardActiveFormats, setForwardActiveFormats] = useState<Set<string>>(new Set());
  const [forwardCurrentFontSize, setForwardCurrentFontSize] = useState('');
  const [forwardCurrentFontFamily, setForwardCurrentFontFamily] = useState('');
  const [forwardShowFormatDropdown, setForwardShowFormatDropdown] = useState(false);
  const [forwardShowFontSizeDropdown, setForwardShowFontSizeDropdown] = useState(false);
  const [forwardShowColorPicker, setForwardShowColorPicker] = useState(false);
  const [forwardShowBgColorPicker, setForwardShowBgColorPicker] = useState(false);
  const [forwardSelectedColor, setForwardSelectedColor] = useState('#000000');
  const [forwardSelectedBgColor, setForwardSelectedBgColor] = useState('#ffffff');
  const [forwardShowEmojiPicker, setForwardShowEmojiPicker] = useState(false);
  const forwardFormatDropdownRef = useRef<HTMLDivElement>(null);
  const forwardFontSizeDropdownRef = useRef<HTMLDivElement>(null);
  const forwardFormatDropdownContainerRef = useRef<HTMLDivElement>(null);

  const [replyActiveFormats, setReplyActiveFormats] = useState<Set<string>>(new Set());
  const [replyCurrentFontSize, setReplyCurrentFontSize] = useState('');
  const [replyCurrentFontFamily, setReplyCurrentFontFamily] = useState('');
  const [replyShowFormatDropdown, setReplyShowFormatDropdown] = useState(false);
  const [replyShowFontSizeDropdown, setReplyShowFontSizeDropdown] = useState(false);
  const [replyShowColorPicker, setReplyShowColorPicker] = useState(false);
  const [replyShowBgColorPicker, setReplyShowBgColorPicker] = useState(false);
  const [replySelectedColor, setReplySelectedColor] = useState('#000000');
  const [replySelectedBgColor, setReplySelectedBgColor] = useState('#ffffff');
  const [replyShowEmojiPicker, setReplyShowEmojiPicker] = useState(false);
  const replyFormatDropdownRef = useRef<HTMLDivElement>(null);
  const replyFontSizeDropdownRef = useRef<HTMLDivElement>(null);
  const replyFormatDropdownContainerRef = useRef<HTMLDivElement>(null);
  const replyMessageRef = useRef<HTMLDivElement>(null);

  const [deletingEmail, setDeletingEmail] = useState(false);
  const [movingToTrash, setMovingToTrash] = useState(false);
  const [restoringFromTrash, setRestoringFromTrash] = useState(false);

  const [processedEmailContent, setProcessedEmailContent] = useState<{ html: string; scopedCSS: string } | null>(null);

  const [showConvertToContactModal, setShowConvertToContactModal] = useState(false);
  const [convertContactName, setConvertContactName] = useState("");
  const [convertContactEmail, setConvertContactEmail] = useState("");
  const [convertContactPersonalEmail, setConvertContactPersonalEmail] = useState("");
  const [convertingContact, setConvertingContact] = useState(false);
  const [creatingContactAndLead, setCreatingContactAndLead] = useState(false);
  const [convertAssignedUserId, setConvertAssignedUserId] = useState<number | null>(null);
  const [convertAssignedTeamId, setConvertAssignedTeamId] = useState<number | null>(null);
  const [tenantUsers, setTenantUsers] = useState<any[]>([]);
  const [teams, setTeams] = useState<any[]>([]);
  const [loadingOptions, setLoadingOptions] = useState(false);
  const [optionsFetched, setOptionsFetched] = useState(false);

  const [apiSourceOptions, setApiSourceOptions] = useState<{ value: number; label: string }[]>([]);
  const [convertSourceId, setConvertSourceId] = useState<number | null>(null);

  const [companyOptions, setCompanyOptions] = useState<{ value: number; label: string }[]>([]);
  const [convertCompanyId, setConvertCompanyId] = useState<number | null>(null);
  const [loadingCompanies, setLoadingCompanies] = useState(false);

  const isValidEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email.trim());
  };

  const createChipsFromEmail = (emailString: string): EmailChip[] => {
    if (!emailString.trim()) return [];

    return emailString
      .split(/[,;\n]/)
      .map(email => email.trim())
      .filter(email => email.length > 0)
      .map(email => ({
        email: email,
        isValid: isValidEmail(email)
      }));
  };

  const getAllEmails = (chips: EmailChip[], currentInput: string): string[] => {
    const chipEmails = chips.filter(chip => chip.isValid).map(chip => chip.email);
    const inputEmails = currentInput.trim() ?
      currentInput.split(/[,;\n]/).map(email => email.trim()).filter(email => email.length > 0 && isValidEmail(email)) :
      [];
    return [...chipEmails, ...inputEmails];
  };

  const handleReplyCcChipCreation = () => {
    if (replyCc.trim()) {
      const newChips = createChipsFromEmail(replyCc);
      setReplyCcChips(prev => [...prev, ...newChips]);
      setReplyCc('');
    }
  };

  const handleReplyRecipientChipCreation = () => {
    if (replyRecipient.trim()) {
      const newChips = createChipsFromEmail(replyRecipient);
      setReplyRecipientChips(prev => [...prev, ...newChips]);
      setReplyRecipient('');
    }
  };

  const handleForwardRecipientChipCreation = () => {
    if (forwardRecipient.trim()) {
      const newChips = createChipsFromEmail(forwardRecipient);
      setForwardRecipientChips(prev => [...prev, ...newChips]);
      setForwardRecipient('');
    }
  };

  const handleForwardCcChipCreation = () => {
    if (forwardCc.trim()) {
      const newChips = createChipsFromEmail(forwardCc);
      setForwardCcChips(prev => [...prev, ...newChips]);
      setForwardCc('');
    }
  };

  const handleReplyCcKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleReplyCcChipCreation();
    }
  };

  const handleReplyRecipientKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleReplyRecipientChipCreation();
    }
  };

  const removeReplyRecipientChip = (index: number) => {
    setReplyRecipientChips(prev => prev.filter((_, i) => i !== index));
  };

  const handleForwardRecipientKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleForwardRecipientChipCreation();
    }
  };

  const handleForwardCcKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleForwardCcChipCreation();
    }
  };

  const removeReplyCcChip = (index: number) => {
    setReplyCcChips(prev => prev.filter((_, i) => i !== index));
  };

  const removeForwardRecipientChip = (index: number) => {
    setForwardRecipientChips(prev => prev.filter((_, i) => i !== index));
  };

  const removeForwardCcChip = (index: number) => {
    setForwardCcChips(prev => prev.filter((_, i) => i !== index));
  };

  const location = useLocation();
  const navigate = useNavigate();
  const { id, section } = useParams();
  const { auth, selectedTenantId, setUnreadCount, importantUnreadCount, setImportantUnreadCount, updateEmailCounts } = useContext<any>(AuthContext);
  const { selectedEmail, setSelectedEmail, clearSelectedEmail } = useEmailContext();
  const dropdownRef = useRef<HTMLDivElement>(null);

  const fromSection = section || 'inbox';
  const isTrash = fromSection === 'trash' || Boolean(emailData?.is_trash);
  const isFolderSection = fromSection.startsWith('folder-');
  const folderIdFromSection = isFolderSection
    ? Number(fromSection.slice('folder-'.length))
    : undefined;

  const searchParams = new URLSearchParams(location.search);
  const currentPage = parseInt(searchParams.get('page') || '1', 10);

  const getNavigationRoute = (section: string, page: number = 1) => {
    let baseRoute: string;
    if (section.startsWith('folder-')) {
      baseRoute = all_routes.emailFolder.replace(':folderId', section.slice('folder-'.length));
    } else {
      switch (section) {
        case 'important':
          baseRoute = all_routes.emailImportant;
          break;
        case 'sent':
          baseRoute = all_routes.emailSent;
          break;
        case 'trash':
          baseRoute = all_routes.emailTrash;
          break;
        case 'draft':
          baseRoute = all_routes.emailDraft;
          break;
        case 'spam':
          baseRoute = all_routes.emailSpam;
          break;
        case 'inbox':
        default:
          baseRoute = all_routes.email;
          break;
      }
    }

    if (page > 1) {
      const separator = baseRoute.includes('?') ? '&' : '?';
      return `${baseRoute}${separator}page=${page}`;
    }

    return baseRoute;
  };

  const fetchEmailDetail = async () => {
    try {
      setLoading(true);
      setError(null);

      const userId = auth?.user_id?.toString() || '';
      if (!userId || !id) {
        throw new Error('User ID or Email ID not found');
      }

      const emailId = parseInt(id);
      const email = await EmailService.getEmailById(emailId);

      if (!email) {
        throw new Error('Email not found');
      }

      setEmailData(email);

      if (!email.is_read) {
        await EmailService.markEmailAsRead(email.mail_message_id);
        email.is_read = true;
      }
      setUnreadCount((prev: number) => Math.max(0, prev - 1));

    } catch (err) {
      console.error('Error fetching email detail:', err);
      setError(err instanceof Error ? err.message : 'Failed to fetch email details');
      showErrorAlert('Failed to fetch email details');
    } finally {
      setLoading(false);
    }
  };

  const setEmailDataDirectly = (email: EmailMessage) => {
    setEmailData(email);
    setLoading(false);
    setError(null);

    if (!email.is_read) {
      EmailService.markEmailAsRead(email.mail_message_id).then(() => {
        setEmailData(prev => prev ? { ...prev, is_read: true } : null);
        setUnreadCount((prev: number) => Math.max(0, prev - 1));
      }).catch(err => {
        console.error('Error marking as read:', err);
      });
    }
  };

  useEffect(() => {
    return () => {
      sessionStorage.setItem("use_email_cache", "true");
    };
  }, []);

  useEffect(() => {
    if (auth?.user_id && id) {

      if (selectedEmail && selectedEmail.mail_message_id.toString() === id) {
        setEmailData(selectedEmail);
        setLoading(false);
        setError(null);

        if (!selectedEmail.is_read) {
          EmailService.markEmailAsRead(selectedEmail.mail_message_id).then(() => {
            setEmailData(prev => prev ? { ...prev, is_read: true } : null);
            setUnreadCount((prev: number) => Math.max(0, prev - 1));
          }).catch(err => {
            console.error('Error marking as read:', err);
          });
        }
      } else {

        fetchEmailDetail();
      }
    }
  }, [auth?.user_id, id, section, selectedEmail]);

  useEffect(() => {
    if (emailData?.content) {
      const processed = sanitizeAndScopeEmailContent(emailData.content, 'scoped-email-content');
      setProcessedEmailContent(processed);
    } else {
      setProcessedEmailContent(null);
    }
  }, [emailData?.content]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node;

      if (dropdownRef.current && !dropdownRef.current.contains(target)) {
        setShowDetails(false);
      }

      if (forwardFormatDropdownContainerRef.current && !forwardFormatDropdownContainerRef.current.contains(target)) {
        forwardCloseAllDropdowns();
      }

      if (replyFormatDropdownContainerRef.current && !replyFormatDropdownContainerRef.current.contains(target)) {
        replyCloseAllDropdowns();
      }

      if (forwardShowEmojiPicker && target.nodeType === Node.ELEMENT_NODE && !(target as Element).closest('.dropdown')) {
        setForwardShowEmojiPicker(false);
      }

      if (replyShowEmojiPicker && target.nodeType === Node.ELEMENT_NODE && !(target as Element).closest('.dropdown')) {
        setReplyShowEmojiPicker(false);
      }
    };

    if (showDetails || forwardShowFormatDropdown || forwardShowFontSizeDropdown || forwardShowColorPicker || forwardShowEmojiPicker || replyShowFormatDropdown || replyShowFontSizeDropdown || replyShowColorPicker || replyShowEmojiPicker) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showDetails, forwardShowFormatDropdown, forwardShowFontSizeDropdown, forwardShowColorPicker, forwardShowEmojiPicker, replyShowFormatDropdown, replyShowFontSizeDropdown, replyShowColorPicker, replyShowEmojiPicker]);

  const handleBackClick = (e: React.MouseEvent) => {
    e.preventDefault();
    sessionStorage.setItem("use_email_cache", "true");
    navigate(getNavigationRoute(isTrash ? 'trash' : fromSection, currentPage));
  };

  const handleClose = () => {
    setIsComposeOpen(false);
    setDraftDataToEdit(null);
    if (fromSection === 'draft') {
      fetchEmailDetail();
    }
  };

  const handleEditDraft = () => {
    if (!emailData) return;
    setDraftDataToEdit(emailData);
    setIsComposeOpen(true);
  };

  const handleMinimize = () => {
    setIsComposeOpen(false);
    setMinimizedEmails(prev => [...prev, Date.now()]);
  };

  const handleStarClick = async () => {
    if (!emailData) return;

    try {
      const newImportanceStatus = await EmailService.toggleEmailImportance(
        emailData.mail_message_id,
        emailData.is_important
      );

      setEmailData(prev => prev ? { ...prev, is_important: newImportanceStatus } : null);

      if (newImportanceStatus) {
        setImportantUnreadCount(importantUnreadCount + 1);
      } else {
        setImportantUnreadCount(Math.max(0, importantUnreadCount - 1));
      }
    } catch (err) {
      console.error('Error toggling star:', err);
      showErrorAlert('Failed to update star status');
    }
  };

  const handleMoveToSpam = async () => {
    if (!emailData) return;

    const result = await showDeleteConfirmationAlert(
      'Move to Spam?',
      'This email will be moved to spam. Are you sure?',
      'Yes, move to spam',
      'Cancel'
    );

    if (!result.isConfirmed) return;

    try {
      await EmailService.moveToSpam(emailData.mail_message_id);
      showSuccessAlert('Email moved to spam successfully');

      setTimeout(() => {
        navigate(getNavigationRoute(fromSection, currentPage));
      }, 1000);
    } catch (err) {
      console.error('Error moving to spam:', err);
      showErrorAlert('Failed to move email to spam');
    }
  };

  const handleRemoveFromSpam = async () => {
    if (!emailData) return;

    try {

      const messageTypes = await EmailService.getMailMessageTypes();
      const inboxType = messageTypes.find(mt => mt.mail_message_type_key === 'INBOX');

      if (!inboxType) {
        throw new Error('Inbox message type not found');
      }

      await EmailService.updateEmailStatus(emailData.mail_message_id, {
        mail_message_type_id: inboxType.mail_message_type_id
      });
      showSuccessAlert('Email removed from spam successfully');

      setTimeout(() => {
        navigate(getNavigationRoute(fromSection, currentPage));
      }, 1000);
    } catch (err) {
      console.error('Error removing email from spam:', err);
      showErrorAlert('Failed to remove email from spam');
    }
  };

  const handleMoveToTrash = async () => {
    if (!emailData || movingToTrash) return;

    if (isTrash) {
      return handleDeleteEmail();
    }

    try {
      setMovingToTrash(true);

      await EmailService.moveToTrash(emailData.mail_message_id, {
        is_trash: true,
        is_important: false,
        is_read: true
      });

      setEmailData(prev => prev ? {
        ...prev,
        is_trash: true,
        is_important: false,
        is_read: true
      } : null);

      setImportantUnreadCount(Math.max(0, importantUnreadCount - 1));

      showSuccessAlert('Email moved to trash successfully');

      localStorage.setItem('email_refresh_needed', fromSection);
      localStorage.setItem('email_refresh_timestamp', Date.now().toString());

      navigate(getNavigationRoute(fromSection, currentPage));
    } catch (err) {
      console.error('Error moving email to trash:', err);
      showErrorAlert('Failed to move email to trash');
    } finally {
      setMovingToTrash(false);
    }
  };



  const handleMarkAsUnread = async () => {
    if (!emailData) return;

    try {
      await EmailService.markEmailAsUnread(emailData.mail_message_id);

      setEmailData(prev => prev ? { ...prev, is_read: false } : null);

      showSuccessAlert('Email marked as unread');
    } catch (err) {
      console.error('Error marking as unread:', err);
      showErrorAlert('Failed to mark email as unread');
    }
  };

  const handleDeleteEmail = async () => {
    if (!emailData || deletingEmail) return;

    try {
      const result = await showDeleteConfirmationAlert(
        'Delete Email Permanently?',
        'Are you sure you want to permanently delete this email? This action cannot be undone.',
        'Yes, delete permanently',
        'Cancel'
      );

      if (!result.isConfirmed) return;

      setDeletingEmail(true);

      await EmailService.deleteEmail(emailData.mail_message_id);

      showSuccessAlert('Email deleted Permanently');

      const redirectSection = isTrash ? 'trash' : fromSection;
      localStorage.setItem('email_refresh_needed', redirectSection);
      localStorage.setItem('email_refresh_timestamp', Date.now().toString());

      navigate(getNavigationRoute(redirectSection, currentPage));
    } catch (err) {
      console.error('Error deleting email:', err);
      showErrorAlert('Failed to delete email');
    } finally {
      setDeletingEmail(false);
    }
  };

  const handleRestoreFromTrash = async () => {
    if (!emailData || restoringFromTrash) return;

    try {
      setRestoringFromTrash(true);

      await EmailService.updateEmailStatus(emailData.mail_message_id, {
        is_trash: false
      });

      setEmailData(prev => prev ? {
        ...prev,
        is_trash: false
      } : null);

      showSuccessAlert('Email restored successfully');

      const redirectSection = isTrash ? 'trash' : fromSection;
      localStorage.setItem('email_refresh_needed', redirectSection);
      localStorage.setItem('email_refresh_timestamp', Date.now().toString());

      navigate(getNavigationRoute(redirectSection, currentPage));
    } catch (err) {
      console.error('Error restoring email:', err);
      showErrorAlert('Failed to restore email');
    } finally {
      setRestoringFromTrash(false);
    }
  };

  const handleFileDownload = async (fileUrl: string, fileName: string) => {
    try {
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.error('Error downloading file:', error);
      showErrorAlert('Failed to download file');
    }
  };

  const handleOpenCreateContactModal = async () => {
    if (!emailData) return;
    const senderInfo = extractSenderInfo(emailData.send_from);
    setConvertContactName(senderInfo.name || "");
    setConvertContactEmail(senderInfo.email || "");
    const ccEmail = emailData.mail_cc ? emailData.mail_cc.split(',')[0].trim() : "";
    setConvertContactPersonalEmail(ccEmail);
    setConvertAssignedUserId(null);
    setConvertAssignedTeamId(null);
    setConvertCompanyId(null);

    const emailSource = apiSourceOptions.find((s: any) => s.label.toLowerCase() === 'email');
    if (emailSource) {
      setConvertSourceId(emailSource.value);
    } else {
      setConvertSourceId(null);
    }

    setShowConvertToContactModal(true);

    if (selectedTenantId && !optionsFetched) {
      setLoadingOptions(true);
      try {
        const usersRes = await ChatService.getTenantUsers(Number(selectedTenantId));
        setTenantUsers(usersRes.results || []);
      } catch (error) { }
      try {
        const teamsRes = await ChatService.getTeams(Number(selectedTenantId));
        setTeams(teamsRes.results || []);
      } catch (error) { }

      try {
        const authHeader = localStorage.getItem("authCred");
        const sourcesRes = await fetch(`${API_BASE_URL}/lifecycle-source/?tenant_id=${selectedTenantId}`, {
          headers: { "Content-Type": "application/json", Authorization: `Basic ${authHeader}` },
        });
        if (sourcesRes.ok) {
          const data = await sourcesRes.json();
          const results = data.results || data;
          const formatted = results
            .filter((item: any) => item.is_active !== false)
            .sort((a: any, b: any) => a.source_order - b.source_order)
            .map((item: any) => ({
              value: item.lifecycle_source_id,
              label: item.lifecycle_source_display_name,
            }));
          setApiSourceOptions(formatted);

          const emailSrc = formatted.find((s: any) => s.label.toLowerCase() === 'email');
          if (emailSrc) {
            setConvertSourceId(emailSrc.value);
          }
        }
      } catch (error) { console.error("Error fetching sources:", error); }

      try {
        const authHeader = localStorage.getItem("authCred");
        const compRes = await fetch(`${API_BASE_URL}/company/?tenant_id=${selectedTenantId}&response_mode=light`, {
          headers: { "Content-Type": "application/json", Authorization: `Basic ${authHeader}` },
        });
        if (compRes.ok) {
          const data = await compRes.json();
          const results = data.results || [];
          const formatted = results.map((item: any) => ({
            value: item.company_id,
            label: item.company_name,
          }));
          setCompanyOptions(formatted);
        }
      } catch (error) { console.error("Error fetching companies:", error); }

      setOptionsFetched(true);
      setLoadingOptions(false);
    }
  };

  const handleCreateCompany = async (inputValue: string) => {
    const result = await MySwal.fire({
      title: 'Create Company',
      input: 'text',
      inputLabel: 'Company Name',
      inputValue: inputValue,
      showCancelButton: true,
      confirmButtonText: 'Create',
      cancelButtonText: 'Cancel',
      didOpen: () => {
        const swalContainer = document.querySelector('.swal2-container');
        if (swalContainer) {
          (swalContainer as HTMLElement).style.zIndex = '10005';
        }
      },
      inputValidator: (value) => {
        if (!value) {
          return 'Company name is required!';
        }
      }
    });

    if (result.isConfirmed) {
      const finalCompanyName = result.value;
      if (!selectedTenantId || !auth?.user_id) return;
      try {
        setLoadingCompanies(true);
        const authHeader = localStorage.getItem("authCred");
        const payload = {
          company_name: finalCompanyName,
          tenant_id: Number(selectedTenantId),
          created_by: Number(auth.user_id),
          updated_by: Number(auth.user_id),
        };
        
        const response = await fetch(`${API_BASE_URL}/company/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Basic ${authHeader}`,
          },
          body: JSON.stringify(payload),
        });

        if (!response.ok) {
          throw new Error("Failed to create company");
        }

        const newCompany = await response.json();
        const newOption = { value: newCompany.company_id, label: newCompany.company_name };
        
        setCompanyOptions((prev) => [...prev, newOption]);
        setConvertCompanyId(newOption.value);

        MySwal.fire({
          icon: "success",
          title: "Company Created",
          text: `Company "${finalCompanyName}" created successfully.`,
          timer: 2000,
          didOpen: () => {
            const swalContainer = document.querySelector('.swal2-container');
            if (swalContainer) {
              (swalContainer as HTMLElement).style.zIndex = '10005';
            }
          }
        });
      } catch (error) {
        console.error("Error creating company:", error);
        MySwal.fire({
          icon: "error",
          title: "Failed to Create Company",
          text: "Could not create company. Please try again.",
          timer: 2000,
          didOpen: () => {
            const swalContainer = document.querySelector('.swal2-container');
            if (swalContainer) {
              (swalContainer as HTMLElement).style.zIndex = '10005';
            }
          }
        });
      } finally {
        setLoadingCompanies(false);
      }
    }
  };

  const handleConvertToContact = async () => {
    if (!emailData || !selectedTenantId || !auth?.user_id) return;
    setConvertingContact(true);
    try {
      const nameParts = convertContactName.trim().split(/\s+/);
      const firstName = nameParts[0] || "";
      const lastName = nameParts.slice(1).join(" ") || "";
      const payload: any = {
        first_name: firstName,
        last_name: lastName,
        tenant_id: Number(selectedTenantId),
        created_by: Number(auth.user_id),
        updated_by: Number(auth.user_id),
        is_active: true,
      };
      if (convertContactEmail.trim()) payload.primary_email = convertContactEmail.trim();
      if (convertContactPersonalEmail.trim()) payload.personal_email = convertContactPersonalEmail.trim();
      if (convertAssignedUserId) payload.assigned_user_id = convertAssignedUserId;
      if (convertAssignedTeamId) payload.assigned_team_id = convertAssignedTeamId;
      if (convertCompanyId) payload.company_id = convertCompanyId;
      if (convertSourceId) payload.lifecycle_source_id = convertSourceId;

      await ChatService.createContact(payload);

      setShowConvertToContactModal(false);
      setConvertContactName("");
      setConvertContactEmail("");
      setConvertContactPersonalEmail("");
      setConvertAssignedUserId(null);
      setConvertAssignedTeamId(null);

      MySwal.fire({
        icon: "success",
        title: "Contact Created",
        text: "Contact has been created successfully.",
        timer: 2000,
      });
    } catch (error) {
      MySwal.fire({
        icon: "error",
        title: "Failed to Create Contact",
        text: "Could not create contact. Please try again.",
        timer: 2000,
      });
    } finally {
      setConvertingContact(false);
    }
  };

  const handleConvertToContactAndCreateLead = async () => {
    if (!emailData || !selectedTenantId || !auth?.user_id) return;
    setCreatingContactAndLead(true);
    try {
      const nameParts = convertContactName.trim().split(/\s+/);
      const firstName = nameParts[0] || "";
      const lastName = nameParts.slice(1).join(" ") || "";
      const contactPayload: any = {
        first_name: firstName,
        last_name: lastName,
        tenant_id: Number(selectedTenantId),
        created_by: Number(auth.user_id),
        updated_by: Number(auth.user_id),
        is_active: true,
      };
      if (convertContactEmail.trim()) contactPayload.primary_email = convertContactEmail.trim();
      if (convertContactPersonalEmail.trim()) contactPayload.personal_email = convertContactPersonalEmail.trim();
      if (convertAssignedUserId) contactPayload.assigned_user_id = convertAssignedUserId;
      if (convertAssignedTeamId) contactPayload.assigned_team_id = convertAssignedTeamId;
      if (convertCompanyId) contactPayload.company_id = convertCompanyId;
      if (convertSourceId) contactPayload.lifecycle_source_id = convertSourceId;

      const newContact = await ChatService.createContact(contactPayload);

      const firstStageId = await ChatService.getFirstLeadStageId(Number(selectedTenantId));

      const leadTitle = convertContactName.trim();
      const leadPayload: any = {
        title: leadTitle,
        tenant_id: Number(selectedTenantId),
        created_by: Number(auth.user_id),
        updated_by: Number(auth.user_id),
        primary_contact: newContact.contact_id,
        lifecycle_type_stage_id: firstStageId,
        priority: "Low",
      };
      if (convertAssignedUserId) leadPayload.assigned_user_id = convertAssignedUserId;
      if (convertAssignedTeamId) leadPayload.assigned_team_id = convertAssignedTeamId;
      if (convertCompanyId) leadPayload.company_id = convertCompanyId;
      if (convertSourceId) leadPayload.lifecycle_source_id = convertSourceId;
      await ChatService.createLead(leadPayload);

      setShowConvertToContactModal(false);
      setConvertContactName("");
      setConvertContactEmail("");
      setConvertContactPersonalEmail("");
      setConvertAssignedUserId(null);
      setConvertAssignedTeamId(null);

      MySwal.fire({
        icon: "success",
        title: "Contact & Lead Created",
        text: "Contact has been created and a lead has been assigned successfully.",
        timer: 2000,
      });
    } catch (error) {
      MySwal.fire({
        icon: "error",
        title: "Failed to Create Contact & Lead",
        text: "An error occurred. Please try again.",
        timer: 2000,
      });
    } finally {
      setCreatingContactAndLead(false);
    }
  };

  const handleReplyClick = () => {
    if (!emailData) return;

    if (isForwardMode) {
      setIsForwardMode(false);
      setForwardContent('');
      setForwardRecipient('');
      setOptionalMessage('');
      setForwardCc('');
      setShowForwardCc(false);
    }

    const senderInfo = extractSenderInfo(emailData.send_from);
    const initialToEmail = senderInfo.email || emailData.send_from || '';
    if (initialToEmail) {
      setReplyRecipientChips(createChipsFromEmail(initialToEmail));
    } else {
      setReplyRecipientChips([]);
    }
    setReplyRecipient('');
    setReplyCc('');
    setReplyCcChips([]);
    setShowReplyCc(false);
    setReplyAttachments([]);

    setIsReplyMode(true);
    setReplyContent('');

    setTimeout(() => {
      const replyContainer = document.querySelector('.email-reply-container');
      if (replyContainer) {
        replyContainer.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest'
        });
      }
    }, 100);
  };

  const handleSendReply = async () => {
    if (!emailData || !replyContent.trim()) return;

    let allRecipientEmails = getAllEmails(replyRecipientChips, replyRecipient);
    if (allRecipientEmails.length === 0) {
      showErrorAlert('Please enter at least one valid recipient email');
      return;
    }

    try {
      setSendingReply(true);
      const replySubject = emailData.subject.startsWith('Re:') ? emailData.subject : `Re: ${emailData.subject}`;

      const userId = auth?.user_id?.toString() || '';
      const providers = await EmailService.getMailProviders(userId);

      if (providers.length === 0) {
        showErrorAlert('No email providers available');
        return;
      }

      const selectedProvider = providers[0];
      const cleanHtml = replyContent
        .replace(/ data-start="[^"]*"/g, '')
        .replace(/ data-end="[^"]*"/g, '');

      const hasHtmlTags = /<[^>]+>/.test(cleanHtml);

      const payload: SendEmailPayload = {
        to: allRecipientEmails,
        subject: replySubject,
        body: cleanHtml,
        is_html: hasHtmlTags,
        user_id: userId
      };

      const allCcEmails = getAllEmails(replyCcChips, replyCc);
      if (allCcEmails.length > 0) {
        payload.cc = allCcEmails;
      }

      if (replyAttachments.length > 0) {

        const formData = new FormData();

        formData.append('to', JSON.stringify(payload.to));
        if (payload.cc) {
          formData.append('cc', JSON.stringify(payload.cc));
        }
        formData.append('subject', payload.subject);
        formData.append('body', payload.body);
        formData.append('is_html', payload.is_html.toString());
        formData.append('user_id', payload.user_id);

        replyAttachments.forEach((file, index) => {
          formData.append('attachments', file);
        });

        await EmailService.sendEmailWithBinaryAttachments(selectedProvider.mail_provider_key, formData);
      } else {

        await EmailService.sendEmail(selectedProvider.mail_provider_key, payload);
      }

      showSuccessAlert('Reply sent successfully!');
      setIsReplyMode(false);
      setReplyContent('');

      localStorage.setItem('email_refresh_needed', 'inbox');
      localStorage.setItem('email_refresh_timestamp', Date.now().toString());

      setTimeout(() => {
        navigate(all_routes.email);
      }, 1500);
    } catch (error) {
      console.error('Error sending reply:', error);
      showErrorAlert('Failed to send reply');
    } finally {
      setSendingReply(false);
    }
  };

  const handleCancelReply = () => {
    setIsReplyMode(false);
    setReplyContent('');
    setReplyRecipient('');
    setReplyRecipientChips([]);
    setReplyCc('');
    setReplyCcChips([]);
    setShowReplyCc(false);
    setReplyAttachments([]);
  };

  const handleForwardClick = () => {
    if (!emailData) return;

    if (isReplyMode) {
      setIsReplyMode(false);
      setReplyContent('');
      setReplyRecipient('');
      setReplyRecipientChips([]);
      setReplyCc('');
      setShowReplyCc(false);
    }

    const forwardSubject = emailData.subject.startsWith('Fwd:') ? emailData.subject : `Fwd: ${emailData.subject}`;

    setIsForwardMode(true);
    setForwardContent(emailData.content);
    setForwardRecipient('');
    setOptionalMessage('');
    setForwardAttachments([]);

    if (emailData.attachments && emailData.attachments.length > 0) {
      emailData.attachments.forEach(async (attachment) => {
        const url = attachment.attachement_url || attachment.attachment_url || '';
        if (url) {
          try {
            const response = await fetch(url);
            if (response.ok) {
              const blob = await response.blob();
              const fileName = url.split('/').pop() || `attachment-${Date.now()}`;
              const file = new File([blob], fileName, { type: blob.type });
              setForwardAttachments(prev => [...prev, file]);
            }
          } catch (error) {
            console.error('Error loading attachment for forward:', error);
          }
        }
      });
    }

    setTimeout(() => {
      const forwardContainer = document.querySelector('.email-forward-container');
      if (forwardContainer) {
        forwardContainer.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest'
        });
      }
    }, 100);
  };

  const handleSendForward = async () => {
    if (!emailData) return;



    let allRecipientEmails = getAllEmails(forwardRecipientChips, forwardRecipient);


    if (allRecipientEmails.length === 0) {
      showErrorAlert('Please enter at least one valid recipient email');
      return;
    }

    try {
      setSendingForward(true);


      const forwardSubject = emailData.subject.startsWith('Fwd:') ? emailData.subject : `Fwd: ${emailData.subject}`;

      const userId = auth?.user_id?.toString() || '';


      const providers = await EmailService.getMailProviders(userId);


      if (providers.length === 0) {
        showErrorAlert('No email providers available');
        return;
      }

      const selectedProvider = providers[0];

      const forwardedMessageHtml = `
<div style="border-left: 2px solid #ccc; padding-left: 12px; margin: 16px 0; color: #666; font-size: 13px;">
  <div style="margin-bottom: 8px; color: #999; font-size: 12px; border-bottom: 1px solid #eee; padding-bottom: 8px;">
    ---------- Forwarded message ---------
  </div>
  <div style="margin-bottom: 4px;"><strong>From:</strong> ${emailData.send_from}</div>
  <div style="margin-bottom: 4px;"><strong>Date:</strong> ${formatFullEmailDate(emailData.email_datetime)}</div>
  <div style="margin-bottom: 4px;"><strong>Subject:</strong> ${emailData.subject}</div>
  <div style="margin-bottom: 4px;"><strong>To:</strong> ${emailData.send_to}</div>
  ${emailData.mail_cc ? `<div style="margin-bottom: 4px;"><strong>CC:</strong> ${emailData.mail_cc}</div>` : ''}
  <div style="margin-top: 12px; border-top: 1px solid #eee; padding-top: 12px;">
    ${emailData.content}
  </div>
</div>
      `.trim();

      const combinedContent = optionalMessage.trim()
        ? `<div style="margin-bottom: 16px;">${optionalMessage.trim().replace(/\n/g, '<br>')}</div>${forwardedMessageHtml}`
        : forwardedMessageHtml;

      const cleanHtml = combinedContent
        .replace(/ data-start="[^"]*"/g, '')
        .replace(/ data-end="[^"]*"/g, '');

      const payload: SendEmailPayload = {
        to: allRecipientEmails,
        subject: forwardSubject,
        body: cleanHtml,
        is_html: true,
        user_id: userId
      };

      const allCcEmails = getAllEmails(forwardCcChips, forwardCc);
      if (allCcEmails.length > 0) {
        payload.cc = allCcEmails;
      }



      if (forwardAttachments.length > 0) {

        const formData = new FormData();

        formData.append('to', JSON.stringify(payload.to));
        if (payload.cc) {
          formData.append('cc', JSON.stringify(payload.cc));
        }
        formData.append('subject', payload.subject);
        formData.append('body', payload.body);
        formData.append('is_html', payload.is_html.toString());
        formData.append('user_id', payload.user_id);

        forwardAttachments.forEach((file, index) => {
          formData.append('attachments', file);
        });

        await EmailService.sendEmailWithBinaryAttachments(selectedProvider.mail_provider_key, formData);

      } else {


        await EmailService.sendEmail(selectedProvider.mail_provider_key, payload);

      }

      showSuccessAlert('Email forwarded successfully!');
      setIsForwardMode(false);
      setForwardContent('');
      setForwardRecipient('');
      setForwardRecipientChips([]);
      setOptionalMessage('');
      setForwardCc('');
      setForwardCcChips([]);
      setShowForwardCc(false);
      setForwardAttachments([]);

      localStorage.setItem('email_refresh_needed', 'inbox');
      localStorage.setItem('email_refresh_timestamp', Date.now().toString());

      setTimeout(() => {
        navigate(all_routes.email);
      }, 1500);
    } catch (error) {
      console.error('Error forwarding email:', error);
      showErrorAlert('Failed to forward email');
    } finally {
      setSendingForward(false);
    }
  };

  const handleCancelForward = () => {
    setIsForwardMode(false);
    setForwardContent('');
    setForwardRecipient('');
    setForwardRecipientChips([]);
    setOptionalMessage('');
    setForwardCc('');
    setForwardCcChips([]);
    setShowForwardCc(false);
    setForwardAttachments([]);
    setIsForwardDropdownOpen(true);
    setStoredRange(null);
    setShowForwardLinkInput(false);
    setForwardLinkUrl('');
    setForwardLinkText('');
  };

  const handleReplyFileClick = () => {
    replyFileInputRef.current?.click();
  };

  const handleReplyFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files || []);
    if (files.length > 0) {
      setReplyAttachments(prev => [...prev, ...files]);
    }
    if (e.target) {
      e.target.value = '';
    }
  };

  const handleRemoveReplyAttachment = (index: number) => {
    setReplyAttachments(prev => prev.filter((_, i) => i !== index));
  };

  const handleForwardFileClick = () => {
    forwardFileInputRef.current?.click();
  };

  const handleForwardFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files || []);
    if (files.length > 0) {
      setForwardAttachments(prev => [...prev, ...files]);
    }
    if (e.target) {
      e.target.value = '';
    }
  };

  const handleRemoveForwardAttachment = (index: number) => {
    setForwardAttachments(prev => prev.filter((_, i) => i !== index));
  };

  const forwardSaveCurrentRange = () => {
    const selection = window.getSelection();
    if (selection && selection.rangeCount > 0) {
      setStoredRange(selection.getRangeAt(0).cloneRange());
    }
  };

  const forwardRestoreRange = () => {
    if (storedRange && forwardMessageRef.current) {
      const selection = window.getSelection();
      selection?.removeAllRanges();
      selection?.addRange(storedRange);
      forwardMessageRef.current.focus();
    }
  };

  const forwardCheckFormatState = () => {
    if (!forwardMessageRef.current) return;

    const selection = window.getSelection();
    if (!selection || selection.rangeCount === 0) return;

    const range = selection.getRangeAt(0);
    const container = range.commonAncestorContainer;
    const element = container.nodeType === Node.TEXT_NODE ? container.parentElement : container as HTMLElement;

    if (!element) return;

    const newActiveFormats = new Set<string>();

    if (element.style.fontWeight === 'bold' || element.tagName === 'B' || element.tagName === 'STRONG') {
      newActiveFormats.add('bold');
    }

    if (element.style.fontStyle === 'italic' || element.tagName === 'I' || element.tagName === 'EM') {
      newActiveFormats.add('italic');
    }

    if (element.style.textDecoration.includes('underline') || element.tagName === 'U') {
      newActiveFormats.add('underline');
    }

    if (element.style.textDecoration.includes('line-through') || element.tagName === 'S' || element.tagName === 'STRIKE') {
      newActiveFormats.add('strikethrough');
    }

    const fontSize = element.style.fontSize;
    if (fontSize) {
      setForwardCurrentFontSize(fontSize);
    }

    const fontFamily = element.style.fontFamily;
    if (fontFamily) {
      setForwardCurrentFontFamily(fontFamily);
    }

    setForwardActiveFormats(newActiveFormats);
  };

  const forwardExecCommand = (command: string, value?: string) => {
    forwardSaveCurrentRange();
    forwardRestoreRange();
    document.execCommand(command, false, value);
    forwardMessageRef.current?.focus();
  };

  const forwardHandleFormatAction = (action: string, value?: string) => {
    switch (action) {
      case 'bold':
        forwardExecCommand('bold');
        break;
      case 'italic':
        forwardExecCommand('italic');
        break;
      case 'underline':
        forwardExecCommand('underline');
        break;
      case 'strikethrough':
        forwardExecCommand('strikethrough');
        break;
      case 'fontSize':
        forwardExecCommand('fontSize', value);
        if (value) setForwardCurrentFontSize(value);
        break;
      case 'fontName':
        forwardExecCommand('fontName', value);
        if (value) setForwardCurrentFontFamily(value);
        break;
      case 'justifyLeft':
        forwardExecCommand('justifyLeft');
        break;
      case 'justifyCenter':
        forwardExecCommand('justifyCenter');
        break;
      case 'justifyRight':
        forwardExecCommand('justifyRight');
        break;
      case 'justifyFull':
        forwardExecCommand('justifyFull');
        break;
      case 'insertUnorderedList':
        forwardExecCommand('insertUnorderedList');
        break;
      case 'insertOrderedList':
        forwardExecCommand('insertOrderedList');
        break;
      case 'foreColor':
        forwardExecCommand('foreColor', value);
        break;
      case 'backColor':
        forwardExecCommand('backColor', value);
        break;
      case 'removeFormat':
        forwardExecCommand('removeFormat');
        setForwardActiveFormats(new Set());
        setForwardCurrentFontSize('');
        setForwardCurrentFontFamily('');
        break;
      case 'subscript':
        forwardExecCommand('subscript');
        break;
      case 'superscript':
        forwardExecCommand('superscript');
        break;
      case 'indent':
        forwardExecCommand('indent');
        break;
      case 'outdent':
        forwardExecCommand('outdent');
        break;
    }

    setTimeout(() => {
      forwardCheckFormatState();
    }, 10);
  };

  const forwardHandleEmojiClick = (emojiData: any) => {
    if (forwardMessageRef.current) {
      forwardSaveCurrentRange();
      forwardRestoreRange();
      document.execCommand('insertText', false, emojiData.emoji);
      setForwardShowEmojiPicker(false);
    }
  };

  const forwardCloseAllDropdowns = () => {
    setForwardShowFormatDropdown(false);
    setForwardShowFontSizeDropdown(false);
    setForwardShowColorPicker(false);
    setForwardShowBgColorPicker(false);
  };

  const handleForwardLinkClick = () => {

    if (forwardMessageRef.current) {
      const selection = window.getSelection();
      if (selection && selection.rangeCount > 0) {
        const range = selection.getRangeAt(0);
        if (forwardMessageRef.current.contains(range.commonAncestorContainer)) {

          setStoredRange(range.cloneRange());
        }
      }
    }
    setShowForwardLinkInput(true);
  };

  const handleForwardInsertLink = () => {
    if (!forwardLinkUrl.trim() || !forwardMessageRef.current) return;

    const url = forwardLinkUrl.trim();
    const absoluteUrl = url.startsWith('http://') || url.startsWith('https://')
      ? url
      : `https://${url}`;

    const linkText = forwardLinkText.trim() || absoluteUrl;

    const linkHtml = `<a href="${absoluteUrl}" target="_blank" rel="noopener noreferrer" style="color: #1a73e8; text-decoration: underline;" title="${absoluteUrl}">${linkText}</a>`;

    forwardMessageRef.current.focus();

    let range;
    const selection = window.getSelection();

    if (storedRange && forwardMessageRef.current.contains(storedRange.commonAncestorContainer)) {

      range = storedRange;
      selection?.removeAllRanges();
      selection?.addRange(range);
    } else if (selection && selection.rangeCount > 0) {

      range = selection.getRangeAt(0);
    } else {

      range = document.createRange();
      range.selectNodeContents(forwardMessageRef.current);
      range.collapse(false);
    }

    if (range) {
      range.deleteContents();
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = linkHtml;
      const linkElement = tempDiv.firstChild;

      if (linkElement) {
        range.insertNode(linkElement);

        range.setStartAfter(linkElement);
        range.setEndAfter(linkElement);
        selection?.removeAllRanges();
        selection?.addRange(range);
      }
    }

    setOptionalMessage(forwardMessageRef.current.innerHTML);

    setShowForwardLinkInput(false);
    setForwardLinkUrl('');
    setForwardLinkText('');
    setStoredRange(null);

    forwardMessageRef.current.focus();
  };

  const handleForwardCancelLink = () => {
    setShowForwardLinkInput(false);
    setForwardLinkUrl('');
    setForwardLinkText('');
    setStoredRange(null);
  };

  const replySaveCurrentRange = () => {
    if (replyMessageRef.current) {
      const selection = window.getSelection();
      if (selection && selection.rangeCount > 0) {
        const range = selection.getRangeAt(0);
        if (replyMessageRef.current.contains(range.commonAncestorContainer)) {
          setStoredRange(range.cloneRange());
        }
      }
    }
  };

  const replyRestoreRange = () => {
    if (storedRange && replyMessageRef.current && replyMessageRef.current.contains(storedRange.commonAncestorContainer)) {
      const selection = window.getSelection();
      selection?.removeAllRanges();
      selection?.addRange(storedRange);
    }
  };

  const replyCheckFormatState = () => {
    if (!replyMessageRef.current) return;

    const selection = window.getSelection();
    if (!selection || selection.rangeCount === 0) return;

    const range = selection.getRangeAt(0);
    if (!replyMessageRef.current.contains(range.commonAncestorContainer)) return;

    const newActiveFormats = new Set<string>();

    if (document.queryCommandState('bold')) {
      newActiveFormats.add('bold');
    }

    if (document.queryCommandState('italic')) {
      newActiveFormats.add('italic');
    }

    if (document.queryCommandState('underline')) {
      newActiveFormats.add('underline');
    }

    if (document.queryCommandState('strikethrough')) {
      newActiveFormats.add('strikethrough');
    }

    const fontSize = document.queryCommandValue('fontSize');
    if (fontSize) {
      setReplyCurrentFontSize(fontSize);
    }

    setReplyActiveFormats(newActiveFormats);
  };

  const replyExecCommand = (command: string, value?: string) => {
    replySaveCurrentRange();
    document.execCommand(command, false, value);
    replyRestoreRange();
    replyCheckFormatState();
  };

  const replyHandleFormatAction = (action: string, value?: string) => {
    if (!replyMessageRef.current) return;

    replyMessageRef.current.focus();

    switch (action) {
      case 'bold':
      case 'italic':
      case 'underline':
      case 'strikethrough':
        replyExecCommand(action);
        break;
      case 'justifyLeft':
      case 'justifyCenter':
      case 'justifyRight':
        replyExecCommand(action);
        break;
      case 'insertUnorderedList':
      case 'insertOrderedList':
        replyExecCommand(action);
        break;
      case 'fontSize':
        if (value) {
          replyExecCommand('fontSize', value);
        }
        break;
      case 'removeFormat':
        replyExecCommand('removeFormat');
        break;
      default:
        break;
    }

    setReplyContent(replyMessageRef.current.innerHTML);
  };

  const replyHandleEmojiClick = (emojiData: any) => {
    if (!replyMessageRef.current) return;

    replyMessageRef.current.focus();
    replySaveCurrentRange();

    const emoji = emojiData.emoji;
    document.execCommand('insertText', false, emoji);

    replyRestoreRange();
    setReplyShowEmojiPicker(false);

    setReplyContent(replyMessageRef.current.innerHTML);
  };

  const replyCloseAllDropdowns = () => {
    setReplyShowFormatDropdown(false);
    setReplyShowFontSizeDropdown(false);
    setReplyShowColorPicker(false);
    setReplyShowBgColorPicker(false);
  };

  useEffect(() => {
    if (forwardMessageRef.current && forwardMessageRef.current.innerHTML !== optionalMessage) {
      forwardMessageRef.current.innerHTML = optionalMessage;
    }
  }, [optionalMessage]);

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="row align-items-center">
            <div className="col-8">
              <h3 className="page-title">Email Details</h3>
            </div>
            <div className="col-4 text-end">
              <div className="head-icons">
                <CollapseHeader />
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <EmailTabs
            activeTab={isFolderSection ? null : (isTrash ? 'trash' : (fromSection as TabKey))}
            activeFolderId={folderIdFromSection}
            onComposeClick={() => {
              setDraftDataToEdit(null);
              setIsComposeOpen(true);
            }}
            onTabClick={(tab) => navigate(getNavigationRoute(tab))}
          />

          <div className="col-lg-9 col-md-12">
            <div className="card mb-4">
              <div className="card-body py-2">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="left-actions d-flex align-items-center">
                    <Link to="#" className="btn btn-icon me-2" onClick={handleBackClick}>
                      <i className="fas fa-arrow-left"></i>
                    </Link>
                    {!isTrash && fromSection !== 'spam' && (
                      <>

                        <button
                          className="btn btn-icon me-2"
                          title="Report spam"
                          onClick={handleMoveToSpam}
                        >
                          <i className="fas fa-exclamation-circle"></i>
                        </button>
                        <button
                          className="btn btn-icon me-2"
                          title="Move to trash"
                          onClick={handleMoveToTrash}
                          disabled={movingToTrash || deletingEmail || restoringFromTrash}
                        >
                          {movingToTrash ? (
                            <i className="fas fa-spinner fa-spin"></i>
                          ) : (
                            <i className="fas fa-trash-alt"></i>
                          )}
                        </button>
                      </>
                    )}
                    {isTrash && (
                      <button
                        className="btn btn-icon me-2"
                        title="Delete email permanently"
                        onClick={handleDeleteEmail}
                        disabled={deletingEmail || movingToTrash || restoringFromTrash}
                      >
                        {deletingEmail ? (
                          <i className="fas fa-spinner fa-spin text-danger"></i>
                        ) : (
                          <i className="fas fa-trash-alt text-danger"></i>
                        )}
                      </button>
                    )}
                    {fromSection === 'spam' && !isTrash && (
                      <>
                        <button
                          className="btn btn-icon me-2"
                          title="Remove from spam"
                          onClick={handleRemoveFromSpam}
                        >
                          <i className="fas fa-ban text-warning"></i>
                        </button>
                        <button
                          className="btn btn-icon me-2"
                          title="Delete email permanently"
                          onClick={handleDeleteEmail}
                          disabled={deletingEmail || movingToTrash || restoringFromTrash}
                        >
                          {deletingEmail ? (
                            <i className="fas fa-spinner fa-spin text-danger"></i>
                          ) : (
                            <i className="fas fa-trash-alt text-danger"></i>
                          )}
                        </button>
                      </>
                    )}
                    <button className="btn btn-icon me-2" title="Mark unread" onClick={handleMarkAsUnread}>
                      <i className="fas fa-envelope"></i>
                    </button>
                    {isTrash && (
                      <button
                        className="btn btn-warning btn-sm"
                        title="Restore from trash"
                        onClick={handleRestoreFromTrash}
                        disabled={restoringFromTrash || deletingEmail || movingToTrash}
                      >
                        {restoringFromTrash ? (
                          <i className="fas fa-spinner fa-spin"></i>
                        ) : (
                          <i className="fas fa-undo"></i>
                        )}
                      </button>
                    )}
                  </div>
                  <div className="d-flex gap-2">
                    <button className="btn btn-primary" onClick={handleOpenCreateContactModal}>
                      <i className="ti ti-user-plus me-2"></i>Create Contact / Lead
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="card">
              <div className="card-body p-4">
                {loading ? (
                  <div className="text-center py-4">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : error ? (
                  <div className="text-center py-4">
                    <div className="alert alert-danger">{error}</div>
                  </div>
                ) : emailData ? (
                  <div>
                    <div className="email-content-header mb-3">
                      <div className="d-flex justify-content-between align-items-start mb-2">
                        <h4 className="email-title mb-0">{emailData.subject}</h4>
                        <span className="text-muted small">
                          {formatDetailedEmailDate(emailData.email_datetime)}
                        </span>
                      </div>
                      <div className="email-info-bar d-flex align-items-center mt-4" style={{ height: '50px' }}>
                        <div className="sender-avatar me-2">
                          <div className="avatar avatar-sm">
                            <img
                              src={male}
                              alt="sender"
                              className="rounded-circle"
                              width="32"
                              height="32"
                              style={{ objectFit: 'cover' }}
                              onError={(e) => {

                                e.currentTarget.style.display = 'none';
                                const parent = e.currentTarget.parentElement;
                                if (parent && !parent.querySelector('.avatar-fallback')) {
                                  const fallback = document.createElement('div');
                                  fallback.className = 'avatar-fallback d-flex align-items-center justify-content-center bg-light rounded-circle';
                                  fallback.style.width = '32px';
                                  fallback.style.height = '32px';
                                  fallback.style.backgroundColor = '#f8f9fa';
                                  fallback.innerHTML = '<i class="ti ti-user" style="font-size: 16px; color: #6c757d;"></i>';
                                  parent.appendChild(fallback);
                                }
                              }}
                            />
                          </div>
                        </div>
                        <div className="email-meta flex-grow-1" style={{ height: '30px' }}>
                          <div className="d-flex justify-content-between align-items-center" style={{ height: '30px' }}>
                            <div>
                              {(() => {
                                const senderInfo = extractSenderInfo(emailData.send_from);
                                const providerTag = getEmailProviderTag(emailData.mail_provider_key);
                                const toList = emailData.send_to ? emailData.send_to.split(',').map((e: string) => e.trim()).filter(Boolean) : [];
                                const toDisplay = toList.length > 2 ? `${toList.length} recipients` : emailData.send_to;
                                return (
                                  <>
                                    <div className="d-flex align-items-center mb-1">
                                      <span className="sender-name fw-bold me-1">{senderInfo.name}</span>
                                      <span className="text-muted">&lt;{senderInfo.email}&gt;</span>
                                    </div>
                                    <div className="text-muted small d-flex align-items-center position-relative" ref={dropdownRef}>
                                      to {toDisplay}
                                      {emailData.crm_entity?.crm_entity_key && (() => {
                                        const crmTag = getCrmEntityTag(emailData.crm_entity.crm_entity_key);
                                        return (
                                          <span
                                            className="badge ms-2"
                                            title={getCrmEntityTooltip(['LEAD', 'PIPELINE', 'DEAL'].includes(emailData.crm_entity.crm_entity_key) ? getLifecycleTypeName(emailData.crm_entity.crm_entity_key) : emailData.crm_entity.crm_entity_display_name, fromSection)}
                                            style={{
                                              backgroundColor: crmTag.bgColor,
                                              color: crmTag.color,
                                              fontSize: '0.6rem',
                                              padding: '0.25rem 0.5rem',
                                              borderRadius: '3px',
                                              cursor: 'help'
                                            }}
                                          >
                                            <i className={`${crmTag.icon}`} style={{ marginRight: '0.15rem', fontSize: '0.7rem' }}></i>
                                            {['LEAD', 'PIPELINE', 'DEAL'].includes(emailData.crm_entity.crm_entity_key) ? getLifecycleTypeName(emailData.crm_entity.crm_entity_key) : emailData.crm_entity.crm_entity_display_name}
                                          </span>
                                        );
                                      })()}
                                      <span
                                        className="badge ms-2"
                                        style={{
                                          backgroundColor: providerTag.bgColor,
                                          color: providerTag.color,
                                          fontSize: '0.6rem',
                                          padding: '0.25rem 0.5rem',
                                          borderRadius: '3px'
                                        }}
                                      >
                                        <i className={providerTag.icon} style={{ marginRight: '0.15rem', fontSize: '0.7rem' }}></i>
                                        {providerTag.label}
                                      </span>

                                      <button className="btn btn-icon btn-sm ms-2" title="Show details" onClick={() => setShowDetails(v => !v)}>
                                        <i className={`fas fa-chevron-${showDetails ? 'up' : 'down'}`}></i>
                                      </button>
                                      {showDetails && (
                                        <div className="email-details-box bg-white border rounded p-3 shadow-sm" style={{
                                          zIndex: 1000,
                                          position: 'absolute',
                                          top: '100%',
                                          left: '0',
                                          minWidth: '650px',
                                          maxHeight: '300px',
                                          overflowY: 'auto',
                                          marginTop: '5px',
                                          fontSize: '0.875rem',
                                          color: '#000000'
                                        }}>
                                          <div className="email-detail-item mb-2">
                                            <div className="d-flex">
                                              <div className="text-muted fw-medium" style={{ minWidth: '60px', flexShrink: 0 }}>From:</div>
                                              <div className="flex-grow-1">{senderInfo.name} &lt;{senderInfo.email}&gt;</div>
                                            </div>
                                          </div>
                                          <div className="email-detail-item mb-2">
                                            <div className="d-flex">
                                              <div className="text-muted fw-medium" style={{ minWidth: '60px', flexShrink: 0 }}>To:</div>
                                              <div className="flex-grow-1">
                                                {emailData.send_to ? emailData.send_to.split(',').map((email: string, idx: number, arr: string[]) => (
                                                  <div key={idx}>{email.trim()}{idx < arr.length - 1 ? ',' : ''}</div>
                                                )) : null}
                                              </div>
                                            </div>
                                          </div>
                                          {emailData.mail_cc && (
                                            <div className="email-detail-item mb-2">
                                              <div className="d-flex">
                                                <div className="text-muted fw-medium" style={{ minWidth: '60px', flexShrink: 0 }}>CC:</div>
                                                <div className="flex-grow-1">{emailData.mail_cc}</div>
                                              </div>
                                            </div>
                                          )}
                                          <div className="email-detail-item mb-2">
                                            <div className="d-flex">
                                              <div className="text-muted fw-medium" style={{ minWidth: '60px', flexShrink: 0 }}>Date:</div>
                                              <div className="flex-grow-1">{formatFullEmailDate(emailData.email_datetime)}</div>
                                            </div>
                                          </div>
                                          <div className="email-detail-item mb-0">
                                            <div className="d-flex">
                                              <div className="text-muted fw-medium" style={{ minWidth: '60px', flexShrink: 0 }}>Subject:</div>
                                              <div className="flex-grow-1">{emailData.subject}</div>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </>
                                );
                              })()}
                            </div>
                            <div className="email-actions d-flex align-items-center">
                              {!isTrash && fromSection !== 'spam' && (
                                <button className="btn btn-icon btn-sm me-1 p-0" title="Star" onClick={handleStarClick}>
                                  <i className={`fas fa-star ${emailData.is_important ? "text-warning" : ""}`}></i>
                                </button>
                              )}
                              <button className="btn btn-icon btn-sm p-0" title="Reply" onClick={handleReplyClick}>
                                <i className="fas fa-reply"></i>
                              </button>
                              {!isTrash && fromSection !== 'spam' && (
                                <button className="btn btn-icon btn-sm p-0 ms-1" title="Forward" onClick={handleForwardClick}>
                                  <i className="fas fa-share"></i>
                                </button>
                              )}
                              {isTrash && (
                                <button className="btn btn-icon btn-sm p-0 ms-1" title="Delete permanently" onClick={handleDeleteEmail}>
                                  <i className="fas fa-trash-alt text-danger"></i>
                                </button>
                              )}
                              {fromSection === 'spam' && !isTrash && (
                                <button className="btn btn-icon btn-sm p-0 ms-1" title="Delete permanently" onClick={handleDeleteEmail}>
                                  <i className="fas fa-trash-alt text-danger"></i>
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="email-body mt-4">
                      <div
                        className="scoped-email-content"
                        dangerouslySetInnerHTML={{ __html: processedEmailContent?.html || emailData.content }}
                        style={{
                          lineHeight: '1.6',
                          fontSize: '14px',
                          color: '#202124',
                          fontFamily: 'inherit'
                        }}
                      />

                      { }
                      {processedEmailContent?.scopedCSS && (
                        <style dangerouslySetInnerHTML={{
                          __html: processedEmailContent.scopedCSS
                        }} />
                      )}

                      { }
                      {!processedEmailContent && (
                        <style dangerouslySetInnerHTML={{
                          __html: `
                          .scoped-email-content b,
                          .scoped-email-content strong {
                          font-weight: bold !important;
                        }
                        
                          .scoped-email-content i,
                          .scoped-email-content em {
                          font-style: italic !important;
                        }
                        
                          .scoped-email-content u {
                          text-decoration: underline !important;
                        }
                        
                          .scoped-email-content s,
                          .scoped-email-content strike {
                          text-decoration: line-through !important;
                        }
                        
                          .scoped-email-content a {
                          color: #1a73e8 !important;
                          text-decoration: underline !important;
                          cursor: pointer !important;
                        }
                        
                          .scoped-email-content a:hover {
                          text-decoration: underline !important;
                          color: #0d5ec7 !important;
                        }
                        
                          .scoped-email-content ul {
                          list-style-type: disc !important;
                          margin: 16px 0 !important;
                          padding-left: 40px !important;
                          display: block !important;
                        }
                        
                          .scoped-email-content ol {
                          list-style-type: decimal !important;
                          margin: 16px 0 !important;
                          padding-left: 40px !important;
                          display: block !important;
                        }
                        
                          .scoped-email-content li {
                          margin: 4px 0 !important;
                          list-style-position: outside !important;
                          display: list-item !important;
                        }
                        
                          .scoped-email-content p {
                          margin: 8px 0 !important;
                        }
                        
                          .scoped-email-content br {
                          line-height: 1.6 !important;
                        }
                        
                          .scoped-email-content div {
                          margin: 0 !important;
                        }
                        
                          .scoped-email-content blockquote {
                          border-left: 3px solid #ccc !important;
                          margin: 16px 0 !important;
                          padding-left: 12px !important;
                          color: #666 !important;
                        }
                        
                          .scoped-email-content h1, .scoped-email-content h2, .scoped-email-content h3, 
                          .scoped-email-content h4, .scoped-email-content h5, .scoped-email-content h6 {
                          margin: 16px 0 8px 0 !important;
                          font-weight: bold !important;
                        }
                        
                          .scoped-email-content pre {
                          background-color: #f8f9fa !important;
                          border: 1px solid #e9ecef !important;
                          border-radius: 4px !important;
                          padding: 8px !important;
                          overflow-x: auto !important;
                          font-family: monospace !important;
                        }
                        
                          .scoped-email-content code {
                          background-color: #f8f9fa !important;
                          padding: 2px 4px !important;
                          border-radius: 3px !important;
                          font-family: monospace !important;
                        }
                      `
                        }} />
                      )}


                      { }
                      {emailData.attachments && emailData.attachments.length > 0 && (
                        <div className="email-attachments mt-4 pt-4 border-top">
                          <div className="gmail-attachment-header">
                            <div className="gmail-attachment-header-content">
                              <i className="fas fa-paperclip gmail-attachment-icon"></i>
                              <span className="gmail-attachment-count">
                                {emailData.attachments.length} Attachment{emailData.attachments.length > 1 ? 's' : ''}
                              </span>
                            </div>
                          </div>
                          <div className="gmail-attachments-container">
                            {emailData.attachments.map((attachment, index) => {

                              const url = attachment.attachement_url || attachment.attachment_url || '';

                              if (!url) {
                                return null;
                              }

                              const fileName = url.split('/').pop() || `attachment-${index + 1}`;
                              const extension = fileName.split('.').pop()?.toUpperCase() || 'FILE';

                              const getFileIcon = (ext: string) => {
                                const extLower = ext.toLowerCase();
                                if (['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg'].includes(extLower)) {
                                  return { icon: 'far fa-file-image', color: '#6F42C1' };
                                } else if (['pdf'].includes(extLower)) {
                                  return { icon: 'far fa-file-pdf', color: '#DC3545' };
                                } else if (['doc', 'docx'].includes(extLower)) {
                                  return { icon: 'far fa-file-word', color: '#824EEB' };
                                } else if (['xls', 'xlsx'].includes(extLower)) {
                                  return { icon: 'far fa-file-excel', color: '#198754' };
                                } else if (['ppt', 'pptx'].includes(extLower)) {
                                  return { icon: 'far fa-file-powerpoint', color: '#DC3545' };
                                } else if (['zip', 'rar', '7z', 'tar', 'gz'].includes(extLower)) {
                                  return { icon: 'far fa-file-archive', color: '#FD7E14' };
                                } else if (['mp4', 'avi', 'mov', 'wmv', 'mkv', 'flv'].includes(extLower)) {
                                  return { icon: 'far fa-file-video', color: '#FD7E14' };
                                } else if (['mp3', 'wav', 'flac', 'aac'].includes(extLower)) {
                                  return { icon: 'far fa-file-audio', color: '#6F42C1' };
                                } else if (['txt', 'rtf'].includes(extLower)) {
                                  return { icon: 'far fa-file-alt', color: '#6C757D' };
                                } else {
                                  return { icon: 'far fa-file', color: '#6C757D' };
                                }
                              };

                              const fileInfo = getFileIcon(extension);

                              return (
                                <div key={attachment.id || index} className="gmail-attachment-item">
                                  <div className="gmail-attachment-content">
                                    <div className="gmail-attachment-icon">
                                      <div className="gmail-file-icon" style={{ backgroundColor: fileInfo.color }}>
                                        <i className={fileInfo.icon}></i>
                                      </div>
                                    </div>
                                    <div className="gmail-attachment-info">
                                      <div className="gmail-file-name">{fileName}</div>
                                      <div className="gmail-file-type">
                                        {extension} • {attachment.size_in_kb ? `${attachment.size_in_kb} KB` : 'Unknown size'}
                                      </div>
                                    </div>
                                    <div className="gmail-attachment-actions">
                                      <button
                                        onClick={() => handleFileDownload(url, fileName)}
                                        className="gmail-download-btn"
                                        title="Download"
                                      >
                                        <i className="fas fa-download"></i>
                                      </button>
                                      <a
                                        href={url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="gmail-open-btn"
                                        title="Open in new tab"
                                      >
                                        <i className="fas fa-external-link-alt"></i>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}


                      <div className="email-actions-bottom mt-3 pt-3 border-top">
                        <div className="d-flex gap-2 justify-content-between flex-wrap">
                          <div className="d-flex gap-2">
                            <button className="btn btn-primary" onClick={handleReplyClick}>
                              <i className="fas fa-reply me-2"></i>Reply
                            </button>
                            {!isTrash && fromSection !== 'spam' && (
                              <button className="btn btn-primary" onClick={handleForwardClick}>
                                <i className="fas fa-share me-2"></i>Forward
                              </button>
                            )}
                            {isTrash && (
                              <button className="btn btn-danger" onClick={handleDeleteEmail}>
                                <i className="fas fa-trash-alt me-2"></i>Delete Permanently
                              </button>
                            )}
                          </div>
                          {fromSection === 'draft' && (
                            <div className="d-flex gap-2">
                              <button className="btn btn-primary" onClick={handleEditDraft}>
                                <i className="fas fa-edit me-2"></i>Edit
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    { }
                    {isReplyMode && emailData && (
                      <div className="email-reply-container mt-4 pt-4 border-top">
                        <div className="reply-header mb-3">
                          <div className="d-flex align-items-center justify-content-between">
                            <div className="reply-info w-100">
                              <div className="reply-to mb-1 d-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center">
                                  <span className="text-muted fw-medium me-2">To:</span>
                                  <div className="email-input-container d-flex flex-wrap align-items-center gap-1" style={{ width: '300px' }}>
                                    {replyRecipientChips.map((chip, index) => (
                                      <span
                                        key={index}
                                        className={`email-chip ${chip.isValid ? 'valid' : 'invalid'}`}
                                      >
                                        {chip.email}
                                        <button
                                          className="chip-remove"
                                          onClick={() => removeReplyRecipientChip(index)}
                                          type="button"
                                        >
                                          ×
                                        </button>
                                      </span>
                                    ))}
                                    <input
                                      type="email"
                                      className="form-control form-control-sm chip-input"
                                      style={{ border: 'none', outline: 'none', boxShadow: 'none', flex: '1', minWidth: '120px' }}
                                      placeholder="Enter recipient email"
                                      value={replyRecipient ?? ""}
                                      onChange={(e) => setReplyRecipient(e.target.value)}
                                      onKeyPress={handleReplyRecipientKeyPress}
                                      onBlur={handleReplyRecipientChipCreation}
                                    />
                                  </div>
                                </div>
                                {!showReplyCc && (
                                  <button
                                    className="btn btn-link btn-sm"
                                    onClick={() => setShowReplyCc(true)}
                                    style={{ color: '#1a73e8', textDecoration: 'none', padding: '0 30px 0 0', fontSize: '14px' }}
                                  >
                                    Cc
                                  </button>
                                )}
                              </div>
                              {showReplyCc && (
                                <div className="reply-cc mb-1">
                                  <span className="text-muted fw-medium me-2">Cc:</span>
                                  <div className="email-input-container d-flex flex-wrap align-items-center gap-1" style={{ width: '300px' }}>
                                    { }
                                    {replyCcChips.map((chip, index) => (
                                      <span
                                        key={index}
                                        className={`email-chip ${chip.isValid ? 'valid' : 'invalid'}`}
                                      >
                                        {chip.email}
                                        <button
                                          className="chip-remove"
                                          onClick={() => removeReplyCcChip(index)}
                                          type="button"
                                        >
                                          ×
                                        </button>
                                      </span>
                                    ))}
                                    <input
                                      type="email"
                                      className="form-control form-control-sm chip-input"
                                      style={{ border: 'none', outline: 'none', boxShadow: 'none', flex: '1', minWidth: '120px' }}
                                      placeholder="Enter CC email"
                                      value={replyCc ?? ""}
                                      onChange={(e) => setReplyCc(e.target.value)}
                                      onKeyPress={handleReplyCcKeyPress}
                                      onBlur={handleReplyCcChipCreation}
                                    />
                                  </div>
                                </div>
                              )}
                              <div className="reply-subject">
                                <span className="text-muted fw-medium me-2">Subject:</span>
                                <span>{emailData.subject.startsWith('Re:') ? emailData.subject : `Re: ${emailData.subject}`}</span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="reply-content">
                          <div
                            ref={replyMessageRef}
                            className="reply-editor border rounded p-3"
                            contentEditable
                            onInput={(e) => setReplyContent(e.currentTarget.innerHTML)}
                            onMouseUp={replyCheckFormatState}
                            onKeyUp={replyCheckFormatState}
                            style={{
                              minHeight: '120px',
                              outline: 'none',
                              fontFamily: 'inherit',
                              fontSize: '14px',
                              lineHeight: '1.5'
                            }}
                            data-placeholder="Write your reply..."
                          />
                        </div>

                        { }
                        {replyAttachments.length > 0 && (
                          <div className="reply-attachments-list mt-2">
                            <div className="attachments-header">
                              <i className="fas fa-paperclip"></i>
                              <span>Attachments ({replyAttachments.length})</span>
                            </div>
                            {replyAttachments.map((file, index) => (
                              <div key={index} className="attachment-item">
                                <i className="fas fa-file"></i>
                                <span className="file-name">{file.name}</span>
                                <span className="file-size">({(file.size / 1024).toFixed(1)} KB)</span>
                                <button
                                  className="btn btn-icon btn-sm"
                                  onClick={() => handleRemoveReplyAttachment(index)}
                                  title="Remove attachment"
                                >
                                  <i className="fas fa-times"></i>
                                </button>
                              </div>
                            ))}
                          </div>
                        )}

                        { }
                        <input
                          type="file"
                          ref={replyFileInputRef}
                          onChange={handleReplyFileChange}
                          multiple
                          accept=".pdf,.doc,.docx,.txt,.jpg,.jpeg,.png,.gif,.bmp,.zip,.rar,.xls,.xlsx,.ppt,.pptx"
                          style={{ display: 'none' }}
                        />

                        <div className="reply-actions mt-3">
                          { }
                          <div className="d-flex justify-content-between align-items-center">
                            <div className="reply-attachments d-flex align-items-center">
                              <button
                                className="btn btn-icon btn-sm me-2"
                                title="Attach files"
                                onClick={handleReplyFileClick}
                              >
                                <i className="fas fa-paperclip"></i>
                                {replyAttachments.length > 0 && (
                                  <span className="attachment-count">{replyAttachments.length}</span>
                                )}
                              </button>
                              <button className="btn btn-icon btn-sm me-2" title="Insert link">
                                <i className="fas fa-link"></i>
                              </button>

                              { }
                              <div className="dropdown d-inline-block me-2 position-relative"
                                onMouseEnter={() => setReplyShowFormatDropdown(true)}
                                onMouseLeave={() => setReplyShowFormatDropdown(false)}>
                                {replyShowFormatDropdown && (
                                  <div className="dropdown-menu show p-2" style={{
                                    position: 'absolute',
                                    bottom: '100%',
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    marginBottom: '0px',
                                    zIndex: 1050,
                                    backgroundColor: '#fff',
                                    border: '1px solid #e9ecef',
                                    borderRadius: '8px',
                                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                    minWidth: '600px'
                                  }}>
                                    <div className="d-flex align-items-center gap-2 justify-content-center">
                                      { }
                                      <div className="d-flex gap-1">
                                        <button
                                          className={`btn btn-icon btn-sm ${replyActiveFormats.has('bold') ? 'btn-primary' : 'btn-outline-secondary'}`}
                                          title="Bold"
                                          onClick={() => replyHandleFormatAction('bold')}
                                          style={{ color: '#000', borderColor: '#000' }}
                                        >
                                          <i className="fas fa-bold" style={{ color: '#000' }}></i>
                                        </button>
                                        <button
                                          className={`btn btn-icon btn-sm ${replyActiveFormats.has('italic') ? 'btn-primary' : 'btn-outline-secondary'}`}
                                          title="Italic"
                                          onClick={() => replyHandleFormatAction('italic')}
                                          style={{ color: '#000', borderColor: '#000' }}
                                        >
                                          <i className="fas fa-italic" style={{ color: '#000' }}></i>
                                        </button>
                                        <button
                                          className={`btn btn-icon btn-sm ${replyActiveFormats.has('underline') ? 'btn-primary' : 'btn-outline-secondary'}`}
                                          title="Underline"
                                          onClick={() => replyHandleFormatAction('underline')}
                                          style={{ color: '#000', borderColor: '#000' }}
                                        >
                                          <i className="fas fa-underline" style={{ color: '#000' }}></i>
                                        </button>
                                        <button
                                          className={`btn btn-icon btn-sm ${replyActiveFormats.has('strikethrough') ? 'btn-primary' : 'btn-outline-secondary'}`}
                                          title="Strikethrough"
                                          onClick={() => replyHandleFormatAction('strikethrough')}
                                          style={{ color: '#000', borderColor: '#000' }}
                                        >
                                          <i className="fas fa-strikethrough" style={{ color: '#000' }}></i>
                                        </button>
                                      </div>

                                      <div className="vr mx-2"></div>

                                      { }
                                      <div className="d-flex gap-1">
                                        <button className="btn btn-icon btn-sm btn-outline-secondary" title="Align Left" onClick={() => replyHandleFormatAction('justifyLeft')} style={{ color: '#000', borderColor: '#000' }}><i className="fas fa-align-left" style={{ color: '#000' }}></i></button>
                                        <button className="btn btn-icon btn-sm btn-outline-secondary" title="Align Center" onClick={() => replyHandleFormatAction('justifyCenter')} style={{ color: '#000', borderColor: '#000' }}><i className="fas fa-align-center" style={{ color: '#000' }}></i></button>
                                        <button className="btn btn-icon btn-sm btn-outline-secondary" title="Align Right" onClick={() => replyHandleFormatAction('justifyRight')} style={{ color: '#000', borderColor: '#000' }}><i className="fas fa-align-right" style={{ color: '#000' }}></i></button>
                                      </div>

                                      <div className="vr mx-2"></div>

                                      { }
                                      <div className="d-flex gap-1">
                                        <button className="btn btn-icon btn-sm btn-outline-secondary" title="Bullet List" onClick={() => replyHandleFormatAction('insertUnorderedList')} style={{ color: '#000', borderColor: '#000' }}><i className="fas fa-list-ul" style={{ color: '#000' }}></i></button>
                                        <button className="btn btn-icon btn-sm btn-outline-secondary" title="Numbered List" onClick={() => replyHandleFormatAction('insertOrderedList')} style={{ color: '#000', borderColor: '#000' }}><i className="fas fa-list-ol" style={{ color: '#000' }}></i></button>
                                      </div>

                                      <div className="vr mx-2"></div>

                                      { }
                                      <div className="d-flex gap-1">
                                        <button className={`btn btn-sm ${replyCurrentFontSize === '1' ? 'btn-primary' : 'btn-outline-secondary'}`} onClick={() => replyHandleFormatAction('fontSize', '1')} style={{ fontSize: '10px', color: '#000', borderColor: '#000' }}>S</button>
                                        <button className={`btn btn-sm ${replyCurrentFontSize === '3' ? 'btn-primary' : 'btn-outline-secondary'}`} onClick={() => replyHandleFormatAction('fontSize', '3')} style={{ fontSize: '12px', color: '#000', borderColor: '#000' }}>M</button>
                                        <button className={`btn btn-sm ${replyCurrentFontSize === '5' ? 'btn-primary' : 'btn-outline-secondary'}`} onClick={() => replyHandleFormatAction('fontSize', '5')} style={{ fontSize: '16px', color: '#000', borderColor: '#000' }}>L</button>
                                        <button className={`btn btn-sm ${replyCurrentFontSize === '7' ? 'btn-primary' : 'btn-outline-secondary'}`} onClick={() => replyHandleFormatAction('fontSize', '7')} style={{ fontSize: '20px', color: '#000', borderColor: '#000' }}>XL</button>
                                      </div>

                                      <div className="vr mx-2"></div>

                                      { }
                                      <button className="btn btn-icon btn-sm btn-outline-secondary" title="Clear Formatting" onClick={() => replyHandleFormatAction('removeFormat')} style={{ color: '#000', borderColor: '#000' }}>
                                        <i className="fas fa-eraser" style={{ color: '#000' }}></i>
                                      </button>
                                    </div>
                                  </div>
                                )}
                                <button className="btn btn-icon btn-sm" title="Formatting options">
                                  <i className="fas fa-font"></i>
                                </button>
                              </div>

                              <div className="dropdown d-inline-block me-2 position-relative">
                                <button className="btn btn-icon btn-sm" title="Insert emoji" onClick={() => setReplyShowEmojiPicker(!replyShowEmojiPicker)}><i className="far fa-smile"></i></button>
                                {replyShowEmojiPicker && (
                                  <div className="dropdown-menu show p-2" style={{
                                    position: 'absolute',
                                    bottom: '100%',
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    marginBottom: '0px',
                                    minWidth: '300px',
                                    maxHeight: '200px',
                                    overflowY: 'auto',
                                    zIndex: 1050,
                                    backgroundColor: '#fff',
                                    border: '1px solid #e9ecef',
                                    borderRadius: '8px',
                                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                                  }}>
                                    <div className="d-flex flex-wrap gap-1">
                                      {['😀', '😃', '😄', '😁', '😆', '😅', '😂', '🤣', '😊', '😇', '🙂', '🙃', '😉', '😌', '😍', '🥰', '😘', '😗', '😙', '😚', '😋', '😛', '😝', '😜', '🤪', '🤨', '🧐', '🤓', '😎', '🤩', '🥳', '😏', '😒', '😞', '😔', '😟', '😕', '🙁', '☹️', '😣', '😖', '😫', '😩', '🥺', '😢', '😭', '😤', '😠', '😡', '🤬', '🤯', '😳', '🥵', '🥶', '😱', '😨', '😰', '😥', '😓', '🤗', '🤔', '🤭', '🤫', '🤥', '😶', '😐', '😑', '😯', '😦', '😧', '😮', '😲', '🥱', '😴', '🤤', '😪', '😵', '🤐', '🥴', '🤢', '🤮', '🤧', '😷', '🤒', '🤕', '🤑', '🤠', '💩', '👻', '💀', '☠️', '👽', '👾', '🤖', '😺', '😸', '😹', '😻', '😼', '😽', '🙀', '😿', '😾'].map(emoji => (<button key={emoji} className="btn btn-sm" style={{ fontSize: '16px', padding: '4px 8px' }} onClick={() => replyHandleEmojiClick({ emoji })}>{emoji}</button>))}
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="reply-send">
                              <button
                                className="btn btn-secondary btn-sm me-2"
                                onClick={handleCancelReply}
                              >
                                Cancel
                              </button>
                              <button
                                className="btn btn-primary btn-sm"
                                onClick={handleSendReply}
                                disabled={sendingReply || !replyContent.trim()}
                              >
                                {sendingReply ? (
                                  <>
                                    <i className="fas fa-spinner fa-spin me-2"></i>
                                    Sending...
                                  </>
                                ) : (
                                  <>
                                    <i className="fas fa-paper-plane me-2"></i>
                                    Send
                                  </>
                                )}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    { }
                    {isForwardMode && emailData && (
                      <div className="email-forward-container mt-4 pt-4 border-top">
                        <div className="forward-header mb-3">
                          <div className="d-flex align-items-center justify-content-between">
                            <div className="forward-info w-100">
                              <div className="forward-to mb-2 d-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center">
                                  <span className="text-muted fw-medium me-2">To:</span>
                                  <div className="email-input-container d-flex flex-wrap align-items-center gap-1" style={{ width: '300px' }}>
                                    { }
                                    {forwardRecipientChips.map((chip, index) => (
                                      <span
                                        key={index}
                                        className={`email-chip ${chip.isValid ? 'valid' : 'invalid'}`}
                                      >
                                        {chip.email}
                                        <button
                                          className="chip-remove"
                                          onClick={() => removeForwardRecipientChip(index)}
                                          type="button"
                                        >
                                          ×
                                        </button>
                                      </span>
                                    ))}
                                    <input
                                      type="email"
                                      className="form-control form-control-sm chip-input"
                                      style={{ border: 'none', outline: 'none', boxShadow: 'none', flex: '1', minWidth: '120px' }}
                                      placeholder="Enter recipient email"
                                      value={forwardRecipient ?? ""}
                                      onChange={(e) => setForwardRecipient(e.target.value)}
                                      onKeyPress={handleForwardRecipientKeyPress}
                                      onBlur={handleForwardRecipientChipCreation}
                                    />
                                  </div>
                                </div>
                                {!showForwardCc && (
                                  <button
                                    className="btn btn-link btn-sm"
                                    onClick={() => setShowForwardCc(true)}
                                    style={{ color: '#1a73e8', textDecoration: 'none', padding: '0 30px 0 0', fontSize: '14px' }}
                                  >
                                    Cc
                                  </button>
                                )}
                              </div>
                              {showForwardCc && (
                                <div className="forward-cc mb-2">
                                  <span className="text-muted fw-medium me-2">Cc:</span>
                                  <div className="email-input-container d-flex flex-wrap align-items-center gap-1" style={{ width: '300px' }}>
                                    { }
                                    {forwardCcChips.map((chip, index) => (
                                      <span
                                        key={index}
                                        className={`email-chip ${chip.isValid ? 'valid' : 'invalid'}`}
                                      >
                                        {chip.email}
                                        <button
                                          className="chip-remove"
                                          onClick={() => removeForwardCcChip(index)}
                                          type="button"
                                        >
                                          ×
                                        </button>
                                      </span>
                                    ))}
                                    <input
                                      type="email"
                                      className="form-control form-control-sm chip-input"
                                      style={{ border: 'none', outline: 'none', boxShadow: 'none', flex: '1', minWidth: '120px' }}
                                      placeholder="Enter CC email"
                                      value={forwardCc ?? ""}
                                      onChange={(e) => setForwardCc(e.target.value)}
                                      onKeyPress={handleForwardCcKeyPress}
                                      onBlur={handleForwardCcChipCreation}
                                    />
                                  </div>
                                </div>
                              )}
                              <div className="forward-subject d-flex align-items-center justify-content-between w-100">
                                <div className="d-flex align-items-center">
                                  <span className="text-muted fw-medium me-2">Subject:</span>
                                  <span>{emailData.subject.startsWith('Fwd:') ? emailData.subject : `Fwd: ${emailData.subject}`}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="forward-content">
                          { }
                          <div className="forward-message-editor mb-3">
                            { }
                            <div
                              ref={forwardMessageRef}
                              className="form-control"
                              contentEditable
                              suppressContentEditableWarning
                              onInput={(e) => setOptionalMessage(e.currentTarget.innerHTML)}
                              onClick={() => {
                                forwardSaveCurrentRange();
                                forwardCheckFormatState();
                              }}
                              onKeyUp={() => {
                                forwardSaveCurrentRange();
                                forwardCheckFormatState();
                              }}
                              style={{
                                minHeight: '120px',
                                border: '1px solid #e9ecef',
                                borderRadius: '8px',
                                fontSize: '14px',
                                lineHeight: '1.5',
                                padding: '12px',
                                fontFamily: 'inherit',
                                outline: 'none',
                                overflowY: 'auto'
                              }}
                            />
                          </div>

                          { }
                          <div className="forwarded-email-dropdown mb-3">
                            <div
                              className="dropdown-header"
                              onClick={() => setIsForwardDropdownOpen(!isForwardDropdownOpen)}
                              style={{
                                backgroundColor: '#f8f9fa',
                                border: '1px solid #e9ecef',
                                borderBottom: isForwardDropdownOpen ? 'none' : '1px solid #e9ecef',
                                padding: '12px 16px',
                                borderRadius: isForwardDropdownOpen ? '8px 8px 0 0' : '8px',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                transition: 'all 0.2s ease',
                                userSelect: 'none'
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = '#f1f3f4';
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = '#f8f9fa';
                              }}
                            >
                              <div className="dropdown-title" style={{
                                fontSize: '14px',
                                fontWeight: '500',
                                color: '#5f6368'
                              }}>
                                <i
                                  className={`fas ${isForwardDropdownOpen ? 'fa-chevron-down' : 'fa-chevron-right'} me-2`}
                                  style={{ fontSize: '12px', transition: 'transform 0.2s ease' }}
                                ></i>
                                ---------- Forwarded message ---------
                              </div>
                              <div className="dropdown-actions">
                                <button
                                  className="btn btn-link btn-sm p-0 me-2"
                                  title="Remove forwarded content"
                                  style={{ color: '#5f6368', fontSize: '12px' }}
                                  onClick={(e) => {
                                    e.stopPropagation();

                                  }}
                                >
                                  <i className="fas fa-times"></i>
                                </button>
                              </div>
                            </div>

                            {isForwardDropdownOpen && (
                              <div className="dropdown-content" style={{
                                backgroundColor: '#ffffff',
                                border: '1px solid #e9ecef',
                                borderTop: 'none',
                                borderRadius: '0 0 8px 8px',
                                padding: '16px',
                                animation: 'slideDown 0.2s ease'
                              }}>
                                <div className="forwarded-email-details">
                                  <div className="email-detail-item mb-2" style={{ fontSize: '13px' }}>
                                    <div className="d-flex">
                                      <div className="text-muted fw-medium" style={{ minWidth: '60px', flexShrink: 0, color: '#5f6368' }}>From:</div>
                                      <div className="flex-grow-1" style={{ color: '#202124' }}>
                                        {extractSenderInfo(emailData.send_from).name} &lt;{extractSenderInfo(emailData.send_from).email}&gt;
                                      </div>
                                    </div>
                                  </div>
                                  <div className="email-detail-item mb-2" style={{ fontSize: '13px' }}>
                                    <div className="d-flex">
                                      <div className="text-muted fw-medium" style={{ minWidth: '60px', flexShrink: 0, color: '#5f6368' }}>To:</div>
                                      <div className="flex-grow-1" style={{ color: '#202124' }}>{emailData.send_to}</div>
                                    </div>
                                  </div>
                                  {emailData.mail_cc && (
                                    <div className="email-detail-item mb-2" style={{ fontSize: '13px' }}>
                                      <div className="d-flex">
                                        <div className="text-muted fw-medium" style={{ minWidth: '60px', flexShrink: 0, color: '#5f6368' }}>CC:</div>
                                        <div className="flex-grow-1" style={{ color: '#202124' }}>{emailData.mail_cc}</div>
                                      </div>
                                    </div>
                                  )}
                                  <div className="email-detail-item mb-2" style={{ fontSize: '13px' }}>
                                    <div className="d-flex">
                                      <div className="text-muted fw-medium" style={{ minWidth: '60px', flexShrink: 0, color: '#5f6368' }}>Date:</div>
                                      <div className="flex-grow-1" style={{ color: '#202124' }}>{formatFullEmailDate(emailData.email_datetime)}</div>
                                    </div>
                                  </div>
                                  <div className="email-detail-item mb-3" style={{ fontSize: '13px' }}>
                                    <div className="d-flex">
                                      <div className="text-muted fw-medium" style={{ minWidth: '60px', flexShrink: 0, color: '#5f6368' }}>Subject:</div>
                                      <div className="flex-grow-1" style={{ color: '#202124' }}>{emailData.subject}</div>
                                    </div>
                                  </div>
                                  { }
                                  <div className="forwarded-email-body" style={{
                                    borderTop: '1px solid #e9ecef',
                                    paddingTop: '12px',
                                    fontSize: '13px',
                                    lineHeight: '1.5',
                                    color: '#202124'
                                  }}>
                                    <div
                                      className="scoped-email-content forwarded-email-content"
                                      dangerouslySetInnerHTML={{ __html: processedEmailContent?.html || emailData.content }}
                                      style={{
                                        fontSize: '13px',
                                        lineHeight: '1.5',
                                        color: '#202124'
                                      }}
                                    />

                                    { }
                                    {processedEmailContent?.scopedCSS && (
                                      <style dangerouslySetInnerHTML={{
                                        __html: processedEmailContent.scopedCSS
                                      }} />
                                    )}

                                    { }
                                    {!processedEmailContent && (
                                      <style dangerouslySetInnerHTML={{
                                        __html: `
                                        .forwarded-email-content b,
                                        .forwarded-email-content strong {
                                          font-weight: bold !important;
                                        }
                                        
                                        .forwarded-email-content i,
                                        .forwarded-email-content em {
                                          font-style: italic !important;
                                        }
                                        
                                        .forwarded-email-content u {
                                          text-decoration: underline !important;
                                        }
                                        
                                        .forwarded-email-content s,
                                        .forwarded-email-content strike {
                                          text-decoration: line-through !important;
                                        }
                                        
                                        .forwarded-email-content a {
                                          color: #1a73e8 !important;
                                          text-decoration: underline !important;
                                          cursor: pointer !important;
                                        }
                                        
                                        .forwarded-email-content a:hover {
                                          text-decoration: underline !important;
                                          color: #0d5ec7 !important;
                                        }
                                        
                                        .forwarded-email-content ul {
                                          list-style-type: disc !important;
                                          margin: 12px 0 !important;
                                          padding-left: 30px !important;
                                          display: block !important;
                                        }
                                        
                                        .forwarded-email-content ol {
                                          list-style-type: decimal !important;
                                          margin: 12px 0 !important;
                                          padding-left: 30px !important;
                                          display: block !important;
                                        }
                                        
                                        .forwarded-email-content li {
                                          margin: 3px 0 !important;
                                          list-style-position: outside !important;
                                          display: list-item !important;
                                        }
                                        
                                        .forwarded-email-content p {
                                          margin: 6px 0 !important;
                                        }
                                        
                                        .forwarded-email-content br {
                                          line-height: 1.5 !important;
                                        }
                                        
                                        .forwarded-email-content div {
                                          margin: 0 !important;
                                        }
                                      `
                                      }} />
                                    )}
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>

                        { }
                        {forwardAttachments.length > 0 && (
                          <div className="forward-attachments-list mt-2">
                            <div className="attachments-header">
                              <i className="fas fa-paperclip"></i>
                              <span>Attachments ({forwardAttachments.length})</span>
                            </div>
                            {forwardAttachments.map((file, index) => (
                              <div key={index} className="attachment-item">
                                <i className="fas fa-file"></i>
                                <span className="file-name">{file.name}</span>
                                <span className="file-size">({(file.size / 1024).toFixed(1)} KB)</span>
                                <button
                                  className="btn btn-icon btn-sm"
                                  onClick={() => handleRemoveForwardAttachment(index)}
                                  title="Remove attachment"
                                >
                                  <i className="fas fa-times"></i>
                                </button>
                              </div>
                            ))}
                          </div>
                        )}

                        { }
                        <input
                          type="file"
                          ref={forwardFileInputRef}
                          onChange={handleForwardFileChange}
                          multiple
                          accept=".pdf,.doc,.docx,.txt,.jpg,.jpeg,.png,.gif,.bmp,.zip,.rar,.xls,.xlsx,.ppt,.pptx"
                          style={{ display: 'none' }}
                        />

                        <div className="forward-actions mt-3">
                          { }
                          <div className="d-flex justify-content-between align-items-center">
                            <div className="forward-attachments d-flex align-items-center">
                              <button className="btn btn-icon btn-sm me-2" title="Attach files" onClick={handleForwardFileClick}><i className="fas fa-paperclip"></i>{forwardAttachments.length > 0 && (<span className="attachment-count">{forwardAttachments.length}</span>)}</button>
                              <button className="btn btn-icon btn-sm me-2" title="Insert link" onClick={handleForwardLinkClick}><i className="fas fa-link"></i></button>

                              { }
                              <div className="dropdown d-inline-block me-2 position-relative"
                                onMouseEnter={() => setForwardShowFormatDropdown(true)}
                                onMouseLeave={() => setForwardShowFormatDropdown(false)}>
                                {forwardShowFormatDropdown && (
                                  <div className="dropdown-menu show p-2" style={{
                                    position: 'absolute',
                                    bottom: '100%',
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    marginBottom: '0px',
                                    zIndex: 1050,
                                    backgroundColor: '#fff',
                                    border: '1px solid #e9ecef',
                                    borderRadius: '8px',
                                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                    minWidth: '600px'
                                  }}>
                                    <div className="d-flex align-items-center gap-2 justify-content-center">
                                      { }
                                      <div className="d-flex gap-1">
                                        <button
                                          className={`btn btn-icon btn-sm ${forwardActiveFormats.has('bold') ? 'btn-primary' : 'btn-outline-secondary'}`}
                                          title="Bold"
                                          onClick={() => forwardHandleFormatAction('bold')}
                                          style={{ color: '#000', borderColor: '#000' }}
                                        >
                                          <i className="fas fa-bold" style={{ color: '#000' }}></i>
                                        </button>
                                        <button
                                          className={`btn btn-icon btn-sm ${forwardActiveFormats.has('italic') ? 'btn-primary' : 'btn-outline-secondary'}`}
                                          title="Italic"
                                          onClick={() => forwardHandleFormatAction('italic')}
                                          style={{ color: '#000', borderColor: '#000' }}
                                        >
                                          <i className="fas fa-italic" style={{ color: '#000' }}></i>
                                        </button>
                                        <button
                                          className={`btn btn-icon btn-sm ${forwardActiveFormats.has('underline') ? 'btn-primary' : 'btn-outline-secondary'}`}
                                          title="Underline"
                                          onClick={() => forwardHandleFormatAction('underline')}
                                          style={{ color: '#000', borderColor: '#000' }}
                                        >
                                          <i className="fas fa-underline" style={{ color: '#000' }}></i>
                                        </button>
                                        <button
                                          className={`btn btn-icon btn-sm ${forwardActiveFormats.has('strikethrough') ? 'btn-primary' : 'btn-outline-secondary'}`}
                                          title="Strikethrough"
                                          onClick={() => forwardHandleFormatAction('strikethrough')}
                                          style={{ color: '#000', borderColor: '#000' }}
                                        >
                                          <i className="fas fa-strikethrough" style={{ color: '#000' }}></i>
                                        </button>
                                      </div>

                                      <div className="vr mx-2"></div>

                                      { }
                                      <div className="d-flex gap-1">
                                        <button className="btn btn-icon btn-sm btn-outline-secondary" title="Align Left" onClick={() => forwardHandleFormatAction('justifyLeft')} style={{ color: '#000', borderColor: '#000' }}><i className="fas fa-align-left" style={{ color: '#000' }}></i></button>
                                        <button className="btn btn-icon btn-sm btn-outline-secondary" title="Align Center" onClick={() => forwardHandleFormatAction('justifyCenter')} style={{ color: '#000', borderColor: '#000' }}><i className="fas fa-align-center" style={{ color: '#000' }}></i></button>
                                        <button className="btn btn-icon btn-sm btn-outline-secondary" title="Align Right" onClick={() => forwardHandleFormatAction('justifyRight')} style={{ color: '#000', borderColor: '#000' }}><i className="fas fa-align-right" style={{ color: '#000' }}></i></button>
                                      </div>

                                      <div className="vr mx-2"></div>

                                      { }
                                      <div className="d-flex gap-1">
                                        <button className="btn btn-icon btn-sm btn-outline-secondary" title="Bullet List" onClick={() => forwardHandleFormatAction('insertUnorderedList')} style={{ color: '#000', borderColor: '#000' }}><i className="fas fa-list-ul" style={{ color: '#000' }}></i></button>
                                        <button className="btn btn-icon btn-sm btn-outline-secondary" title="Numbered List" onClick={() => forwardHandleFormatAction('insertOrderedList')} style={{ color: '#000', borderColor: '#000' }}><i className="fas fa-list-ol" style={{ color: '#000' }}></i></button>
                                      </div>

                                      <div className="vr mx-2"></div>

                                      { }
                                      <div className="d-flex gap-1">
                                        <button className={`btn btn-sm ${forwardCurrentFontSize === '1' ? 'btn-primary' : 'btn-outline-secondary'}`} onClick={() => forwardHandleFormatAction('fontSize', '1')} style={{ fontSize: '10px', color: '#000', borderColor: '#000' }}>S</button>
                                        <button className={`btn btn-sm ${forwardCurrentFontSize === '3' ? 'btn-primary' : 'btn-outline-secondary'}`} onClick={() => forwardHandleFormatAction('fontSize', '3')} style={{ fontSize: '12px', color: '#000', borderColor: '#000' }}>M</button>
                                        <button className={`btn btn-sm ${forwardCurrentFontSize === '5' ? 'btn-primary' : 'btn-outline-secondary'}`} onClick={() => forwardHandleFormatAction('fontSize', '5')} style={{ fontSize: '16px', color: '#000', borderColor: '#000' }}>L</button>
                                        <button className={`btn btn-sm ${forwardCurrentFontSize === '7' ? 'btn-primary' : 'btn-outline-secondary'}`} onClick={() => forwardHandleFormatAction('fontSize', '7')} style={{ fontSize: '20px', color: '#000', borderColor: '#000' }}>XL</button>
                                      </div>

                                      <div className="vr mx-2"></div>

                                      { }
                                      <button className="btn btn-icon btn-sm btn-outline-secondary" title="Clear Formatting" onClick={() => forwardHandleFormatAction('removeFormat')} style={{ color: '#000', borderColor: '#000' }}>
                                        <i className="fas fa-eraser" style={{ color: '#000' }}></i>
                                      </button>
                                    </div>
                                  </div>
                                )}
                                <button className="btn btn-icon btn-sm" title="Formatting options">
                                  <i className="fas fa-font"></i>
                                </button>
                              </div>

                              <div className="dropdown d-inline-block me-2 position-relative">
                                <button className="btn btn-icon btn-sm" title="Insert emoji" onClick={() => setForwardShowEmojiPicker(!forwardShowEmojiPicker)}><i className="far fa-smile"></i></button>
                                {forwardShowEmojiPicker && (
                                  <div className="dropdown-menu show p-2" style={{
                                    position: 'absolute',
                                    bottom: '100%',
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    marginBottom: '0px',
                                    minWidth: '300px',
                                    maxHeight: '200px',
                                    overflowY: 'auto',
                                    zIndex: 1050,
                                    backgroundColor: '#fff',
                                    border: '1px solid #e9ecef',
                                    borderRadius: '8px',
                                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                                  }}>
                                    <div className="d-flex flex-wrap gap-1">
                                      {['😀', '😃', '😄', '😁', '😆', '😅', '😂', '🤣', '😊', '😇', '🙂', '🙃', '😉', '😌', '😍', '🥰', '😘', '😗', '😙', '😚', '😋', '😛', '😝', '😜', '🤪', '🤨', '🧐', '🤓', '😎', '🤩', '🥳', '😏', '😒', '😞', '😔', '😟', '😕', '🙁', '☹️', '😣', '😖', '😫', '😩', '🥺', '😢', '😭', '😤', '😠', '😡', '🤬', '🤯', '😳', '🥵', '🥶', '😱', '😨', '😰', '😥', '😓', '🤗', '🤔', '🤭', '🤫', '🤥', '😶', '😐', '😑', '😯', '😦', '😧', '😮', '😲', '🥱', '😴', '🤤', '😪', '😵', '🤐', '🥴', '🤢', '🤮', '🤧', '😷', '🤒', '🤕', '🤑', '🤠', '💩', '👻', '💀', '☠️', '👽', '👾', '🤖', '😺', '😸', '😹', '😻', '😼', '😽', '🙀', '😿', '😾'].map(emoji => (<button key={emoji} className="btn btn-sm" style={{ fontSize: '16px', padding: '4px 8px' }} onClick={() => forwardHandleEmojiClick({ emoji })}>{emoji}</button>))}
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="d-flex align-items-center">
                              {optionalMessage.trim() && (
                                <button className="btn btn-link btn-sm me-3" title="Clear message" onClick={() => setOptionalMessage('')} style={{ color: '#5f6368', fontSize: '12px' }}>Clear message</button>
                              )}
                              <div className="forward-send">
                                <button className="btn btn-secondary btn-sm me-2" onClick={handleCancelForward}>Cancel</button>
                                <button
                                  className="btn btn-primary btn-sm"
                                  onClick={handleSendForward}
                                  disabled={sendingForward || (getAllEmails(forwardRecipientChips, forwardRecipient).length === 0)}
                                >
                                  {sendingForward ? (
                                    <>
                                      <i className="fas fa-spinner fa-spin me-2"></i>
                                      Sending...
                                    </>
                                  ) : (
                                    <>
                                      <i className="fas fa-paper-plane me-2"></i>
                                      Send
                                    </>
                                  )}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    { }
                    {showForwardLinkInput && (
                      <div style={{
                        position: 'absolute',
                        zIndex: 1000,
                        background: '#fff',
                        border: '1px solid #e9ecef',
                        borderRadius: 8,
                        padding: 16,
                        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                        top: '30%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        minWidth: 320
                      }}>
                        <div className="mb-2">
                          <input
                            type="text"
                            className="form-control mb-2"
                            placeholder="Paste or type a link (https://...)"
                            value={forwardLinkUrl ?? ""}
                            onChange={e => setForwardLinkUrl(e.target.value)}
                            autoFocus
                          />
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Text to display (optional)"
                            value={forwardLinkText ?? ""}
                            onChange={e => setForwardLinkText(e.target.value)}
                          />
                        </div>
                        <div className="d-flex justify-content-end gap-2">
                          <button className="btn btn-sm btn-secondary" onClick={handleForwardCancelLink}>Cancel</button>
                          <button className="btn btn-sm btn-primary" onClick={handleForwardInsertLink} disabled={!forwardLinkUrl.trim()}>Insert</button>
                        </div>
                      </div>
                    )}
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>

        <ComposeEmail
          isOpen={isComposeOpen}
          onClose={handleClose}
          onMinimize={handleMinimize}
          cachedProviders={providers}
          draftData={draftDataToEdit}
        />

        {minimizedEmails.length > 0 && (
          <div className="minimized-emails">
            {minimizedEmails.map(id => (
              <div
                key={id}
                className="minimized-email"
                onClick={() => {
                  setIsComposeOpen(true);
                  setMinimizedEmails(prev => prev.filter(emailId => emailId !== id));
                }}
              >
                New Message
              </div>
            ))}
          </div>
        )}

        {showConvertToContactModal && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.6)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 10000,
            }}
            onClick={() => {
              setShowConvertToContactModal(false);
              setConvertContactName("");
              setConvertContactEmail("");
              setConvertContactPersonalEmail("");
              setConvertSourceId(null);
              setConvertCompanyId(null);
            }}
          >
            <div
              style={{
                backgroundColor: "white",
                borderRadius: "8px",
                padding: "24px",
                minWidth: "800px",
                maxWidth: "900px",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "20px",
                }}
              >
                <h5 style={{ margin: 0, fontWeight: 600 }}>Create Contact from Email</h5>
                <button
                  onClick={() => {
                    setShowConvertToContactModal(false);
                    setConvertContactName("");
                    setConvertContactEmail("");
                    setConvertContactPersonalEmail("");
                    setConvertSourceId(null);
                    setConvertCompanyId(null);
                  }}
                  style={{
                    background: "transparent",
                    border: "none",
                    fontSize: "24px",
                    cursor: "pointer",
                    padding: 0,
                    color: "#666",
                  }}
                >
                  <i className="ti ti-x" />
                </button>
              </div>

              <div style={{ marginBottom: "16px" }}>
                <p style={{ color: "#666", fontSize: "14px", marginBottom: "16px" }}>
                  Create a new contact or lead from this email.
                </p>

                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label
                      style={{
                        display: "block",
                        marginBottom: "6px",
                        fontWeight: 500,
                        fontSize: "14px",
                      }}
                    >
                      Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter name..."
                      value={convertContactName}
                      onChange={(e) => setConvertContactName(e.target.value)}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label
                      style={{
                        display: "block",
                        marginBottom: "6px",
                        fontWeight: 500,
                        fontSize: "14px",
                      }}
                    >
                      Source
                    </label>
                    <select
                      className="form-select"
                      value={convertSourceId || ""}
                      onChange={(e) =>
                        setConvertSourceId(
                          e.target.value ? Number(e.target.value) : null,
                        )
                      }
                    >
                      <option value="">{loadingOptions ? "Loading..." : "-- Select Source --"}</option>
                      {apiSourceOptions.map((source: any) => (
                        <option key={source.value} value={source.value}>
                          {source.label}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-md-6 mb-3">
                    <label
                      style={{
                        display: "block",
                        marginBottom: "6px",
                        fontWeight: 500,
                        fontSize: "14px",
                      }}
                    >
                      Primary Email
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Enter primary email..."
                      value={convertContactEmail}
                      onChange={(e) => setConvertContactEmail(e.target.value)}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label
                      style={{
                        display: "block",
                        marginBottom: "6px",
                        fontWeight: 500,
                        fontSize: "14px",
                      }}
                    >
                      Personal Email (from CC)
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Enter personal email..."
                      value={convertContactPersonalEmail}
                      onChange={(e) => setConvertContactPersonalEmail(e.target.value)}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label
                      style={{
                        display: "block",
                        marginBottom: "6px",
                        fontWeight: 500,
                        fontSize: "14px",
                      }}
                    >
                      Company
                    </label>
                    <CreatableSelect
                      options={companyOptions}
                      value={companyOptions.find(opt => opt.value === convertCompanyId) || null}
                      onChange={(selected: any) => setConvertCompanyId(selected ? selected.value : null)}
                      onCreateOption={handleCreateCompany}
                      isLoading={loadingCompanies}
                      placeholder={loadingCompanies ? "Loading..." : "Search or create company..."}
                      isClearable
                      classNamePrefix="react-select"
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label
                      style={{
                        display: "block",
                        marginBottom: "6px",
                        fontWeight: 500,
                        fontSize: "14px",
                      }}
                    >
                      Assign User
                    </label>
                    <select
                      className="form-select"
                      value={convertAssignedUserId || ""}
                      onChange={(e) =>
                        setConvertAssignedUserId(
                          e.target.value ? Number(e.target.value) : null,
                        )
                      }
                    >
                      <option value="">{loadingOptions ? "Loading..." : "-- Select User --"}</option>
                      {tenantUsers.map((user: any) => (
                        <option key={user.user_id} value={user.user_id}>
                          {user.user_first_name || user.full_name?.split(' ')[0] || ''} {user.user_last_name || user.full_name?.split(' ').slice(1).join(' ') || ''} {user.email ? `(${user.email})` : ''}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-md-6 mb-3">
                    <label
                      style={{
                        display: "block",
                        marginBottom: "6px",
                        fontWeight: 500,
                        fontSize: "14px",
                      }}
                    >
                      Assign Team
                    </label>
                    <select
                      className="form-select"
                      value={convertAssignedTeamId || ""}
                      onChange={(e) =>
                        setConvertAssignedTeamId(
                          e.target.value ? Number(e.target.value) : null,
                        )
                      }
                    >
                      <option value="">{loadingOptions ? "Loading..." : "-- Select Team --"}</option>
                      {teams.map((team: any) => (
                        <option key={team.team_id} value={team.team_id}>
                          {team.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  gap: "8px",
                  justifyContent: "flex-end",
                }}
              >
                <button
                  className="btn btn-light"
                  onClick={() => {
                    setShowConvertToContactModal(false);
                    setConvertContactName("");
                    setConvertContactEmail("");
                    setConvertContactPersonalEmail("");
                    setConvertSourceId(null);
                    setConvertCompanyId(null);
                  }}
                  disabled={convertingContact || creatingContactAndLead}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  onClick={handleConvertToContact}
                  disabled={convertingContact || creatingContactAndLead}
                >
                  {convertingContact ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" />
                      Creating...
                    </>
                  ) : (
                    <>
                      <i className="ti ti-check me-2" />
                      Create Contact Only
                    </>
                  )}
                </button>
                <button
                  className="btn btn-success"
                  onClick={handleConvertToContactAndCreateLead}
                  disabled={convertingContact || creatingContactAndLead}
                >
                  {creatingContactAndLead ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" />
                      Creating...
                    </>
                  ) : (
                    <>
                      <i className="ti ti-user-plus me-2" />
                      Create Contact and Lead
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EmailDetail;










